/* eslint-disable */
import UrlPattern from 'url-pattern';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  SearchParams: any;
  JSON: any;
  Object: any;
};

export type Node = {
  id: Scalars['ID'];
};

export type JampotImage = {
  __typename?: 'JampotImage';
  src: Scalars['String'];
  dominantColor?: Maybe<Scalars['String']>;
};

export type Region = Node & {
  __typename?: 'Region';
  id: Scalars['ID'];
  name: Scalars['String'];
  name1?: Maybe<Scalars['String']>;
  name2?: Maybe<Scalars['String']>;
  name3?: Maybe<Scalars['String']>;
  name1Id?: Maybe<Region>;
  name2Id?: Maybe<Region>;
  name3Id?: Maybe<Region>;
  depth: Scalars['Int'];
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type FleamarketCategory = Node & {
  __typename?: 'FleamarketCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  thumbnail: Scalars['String'];
  webIcon?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type KarrotUserReview = {
  __typename?: 'KarrotUserReview';
  userId?: Maybe<KarrotUser>;
  userImage?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  locationName?: Maybe<KarrotUserH3LocationName>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  articleThumbnail?: Maybe<Scalars['String']>;
  isSeller?: Maybe<Scalars['Boolean']>;
};

export type KarrotUserH3LocationName = {
  __typename?: 'KarrotUserH3LocationName';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type KarrotUser = Node & {
  __typename?: 'KarrotUser';
  id: Scalars['ID'];
  nickname: Scalars['String'];
  regionId: Region;
  profileImage: Scalars['String'];
  reviewCount: Scalars['Int'];
  score: Scalars['Float'];
  scoreSymbol: Scalars['String'];
  regionCheckinsCount: Scalars['Int'];
  userArticleIds: Array<FleamarketArticle>;
  receivedReviews: Array<KarrotUserReview>;
  locationName?: Maybe<KarrotUserH3LocationName>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type FleamarketArticleComment = {
  __typename?: 'FleamarketArticleComment';
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  displayLocationName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  userNickname?: Maybe<Scalars['String']>;
  userProfileImage?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<FleamarketArticleComment>>>;
  isDestroyedUser: Scalars['Boolean'];
  isDestroyedComment: Scalars['Boolean'];
  isBlockedComment: Scalars['Boolean'];
  userId?: Maybe<KarrotUser>;
};

export type FleamarketArticleProperty = {
  __typename?: 'FleamarketArticleProperty';
  title: Scalars['String'];
  content: Scalars['String'];
  displayOrder: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

export type FleamarketArticleH3LocationName = {
  __typename?: 'FleamarketArticleH3LocationName';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export const FleamarketArticleStatus = {
  Ongoing: 'Ongoing',
  Reserved: 'Reserved',
  Closed: 'Closed'
} as const;

export type FleamarketArticleStatus = typeof FleamarketArticleStatus[keyof typeof FleamarketArticleStatus];
export type FleamarketArticle = Node & {
  __typename?: 'FleamarketArticle';
  id: Scalars['ID'];
  title: Scalars['String'];
  categoryId?: Maybe<FleamarketCategory>;
  userId?: Maybe<KarrotUser>;
  regionId: Region;
  createdAt: Scalars['String'];
  boostedAt: Scalars['String'];
  images: Array<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  status: FleamarketArticleStatus;
  price?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  favoriteCount: Scalars['Int'];
  chatCount: Scalars['Int'];
  viewCount: Scalars['Int'];
  recommendedArticlesIds: Array<FleamarketArticle>;
  articlePropertyContents: Array<FleamarketArticleProperty>;
  locationName?: Maybe<FleamarketArticleH3LocationName>;
  comments?: Maybe<Array<Maybe<FleamarketArticleComment>>>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type HomePageSectionFilter = {
  __typename?: 'HomePageSectionFilter';
  price?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type HomePageSection = {
  __typename?: 'HomePageSection';
  header: Scalars['String'];
  position: Scalars['Int'];
  type: Scalars['String'];
  filter?: Maybe<HomePageSectionFilter>;
  articleIds?: Maybe<Array<FleamarketArticle>>;
  categoryIds?: Maybe<Array<FleamarketCategory>>;
};

export type HomePage = Node & {
  __typename?: 'HomePage';
  id: Scalars['ID'];
  sections: Array<HomePageSection>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type AllPage = Node & {
  __typename?: 'AllPage';
  id: Scalars['ID'];
  fleamarketArticles: Array<FleamarketArticle>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CategoriesPage = Node & {
  __typename?: 'CategoriesPage';
  id: Scalars['ID'];
  categoryIds: Array<FleamarketCategory>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type PostActorCoordinates = {
  __typename?: 'PostActorCoordinates';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export const ActorType = {
  BusinessAccount: 'BUSINESS_ACCOUNT',
  User: 'USER'
} as const;

export type ActorType = typeof ActorType[keyof typeof ActorType];
export type PostActor = {
  __typename?: 'PostActor';
  regionId?: Maybe<Region>;
  profileImageUrl: Scalars['String'];
  nickname: Scalars['String'];
  userId?: Maybe<KarrotUser>;
  userType: ActorType;
  coordinates?: Maybe<PostActorCoordinates>;
  businessAccountId?: Maybe<Scalars['String']>;
};

/** 소식 에디터 타입 */
export const BusinessPostEditorType = {
  Blog: 'BLOG',
  Daangn: 'DAANGN'
} as const;

export type BusinessPostEditorType = typeof BusinessPostEditorType[keyof typeof BusinessPostEditorType];
export const PostType = {
  BusinessPost: 'BUSINESS_POST',
  Review: 'REVIEW',
  UserPost: 'USER_POST',
  CommerceProduct: 'COMMERCE_PRODUCT'
} as const;

export type PostType = typeof PostType[keyof typeof PostType];
export const BusinessPostType = {
  Default: 'DEFAULT',
  ClosingTimeSale: 'CLOSING_TIME_SALE'
} as const;

export type BusinessPostType = typeof BusinessPostType[keyof typeof BusinessPostType];
export const BusinessPostClosingTimeSaleStatus = {
  OnSale: 'ON_SALE',
  Closed: 'CLOSED'
} as const;

export type BusinessPostClosingTimeSaleStatus = typeof BusinessPostClosingTimeSaleStatus[keyof typeof BusinessPostClosingTimeSaleStatus];
export const MediaType = {
  Image: 'IMAGE',
  Photo: 'PHOTO',
  Video: 'VIDEO'
} as const;

export type MediaType = typeof MediaType[keyof typeof MediaType];
export type BusinessPostClosingTimeSale = {
  __typename?: 'BusinessPostClosingTimeSale';
  closeTime: Scalars['String'];
  status: BusinessPostClosingTimeSaleStatus;
};

export type BusinessPostComment = {
  __typename?: 'BusinessPostComment';
  /** 댓글 작성자 */
  actor: PostActor;
  /** 제재된 소식인지에 대한 여부 */
  blocked: Scalars['Boolean'];
  /** 댓글 상세 내용 */
  content: Array<Content>;
  /** 댓글 작성 시점 */
  createdAt: Scalars['String'];
  /** 댓글 수정 시점 */
  updatedAt: Scalars['String'];
  /** 댓글 삭제 여부 */
  deleted: Scalars['Boolean'];
  /** 댓글 좋아요 수 */
  likeCount: Scalars['Int'];
  /** 게시 중단 */
  postStopped: Scalars['Boolean'];
  /** 소식 db id */
  postId: Scalars['String'];
  /** 신고된 댓글 */
  reported: Scalars['Boolean'];
  /** 감추는 댓글 */
  secure: Scalars['Boolean'];
  /** 하위 댓글 목록 */
  subComments: Array<BusinessPostComment>;
};

export type BusinessPostCategory = {
  __typename?: 'BusinessPostCategory';
  name: Scalars['String'];
  levels: Array<Scalars['String']>;
};

export const ContentType = {
  Text: 'TEXT',
  Image: 'IMAGE',
  Video: 'VIDEO',
  Link: 'LINK'
} as const;

export type ContentType = typeof ContentType[keyof typeof ContentType];
export type Content = {
  __typename?: 'Content';
  type: ContentType;
  value?: Maybe<Scalars['String']>;
};

export type BusinessPostMediaObject = {
  __typename?: 'BusinessPostMediaObject';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<MediaType>;
  url?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type Counter = {
  __typename?: 'Counter';
  likeCount: Scalars['Int'];
  commentCount: Scalars['Int'];
  viewCount: Scalars['Int'];
  bookmarkCount: Scalars['Int'];
  chatRoomCount: Scalars['Int'];
  callCount: Scalars['Int'];
  followCount: Scalars['Int'];
  exposureCount: Scalars['Int'];
};

export type BusinessPost = Node & {
  __typename?: 'BusinessPost';
  id: Scalars['ID'];
  localProfileId?: Maybe<LocalProfile>;
  targetUri: Scalars['String'];
  promotion?: Maybe<Scalars['String']>;
  /** 삭제 여부 */
  deleted: Scalars['Boolean'];
  /** 소식의 카테고리 */
  category?: Maybe<BusinessPostCategory>;
  /** 감추는 글인지에 대한 정보 */
  hidden: Scalars['Boolean'];
  /** 차단된 소식인지에 대한 정보 */
  blocked: Scalars['Boolean'];
  /** 비즈 소식의 타입 */
  businessPostType?: Maybe<BusinessPostType>;
  /** 소식의 타입 */
  postType: PostType;
  /** 소식의 작성자 */
  actor: PostActor;
  /** 소식 본문 상세 내용 */
  content: Array<Content>;
  /** 이벤트 소식의 메타 정보 */
  closingTimeSale?: Maybe<BusinessPostClosingTimeSale>;
  counter: Counter;
  /** 생성 시점 */
  createdAt: Scalars['String'];
  /** 수정 시점 */
  updatedAt: Scalars['String'];
  /** 지역 */
  regionId?: Maybe<Region>;
  /** 제목 */
  title: Scalars['String'];
  /** 소식 에디터 타입 */
  editorType: BusinessPostEditorType;
  /** 당근 타입 소식의 상단 캐로셀 이미지 */
  mediaObjects: Array<BusinessPostMediaObject>;
  /** 소식에 첨부된 모든 이미지 */
  allMediaObjects?: Maybe<Array<Maybe<BusinessPostMediaObject>>>;
  /**
   * UI 에 노출되어야 하는 댓글 수.
   * comments 는 삭제된 댓글도 가져오기 때문에 정책이 다름.
   */
  commentCount?: Maybe<Scalars['Int']>;
  /** 댓글 비활성화 */
  disableComment: Scalars['Boolean'];
  /** 채팅 비활성화 */
  disableChatting: Scalars['Boolean'];
  images: Array<BusinessPostMediaObject>;
  oldestComments: Array<BusinessPostComment>;
  latestComments: Array<BusinessPostComment>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

/** 위경도 좌표 */
export type BusinessProfileCoordinates = {
  __typename?: 'BusinessProfileCoordinates';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export const MoneyCurrency = {
  Won: 'WON'
} as const;

export type MoneyCurrency = typeof MoneyCurrency[keyof typeof MoneyCurrency];
export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float'];
  currency: MoneyCurrency;
};

export const ProductRepresentStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type ProductRepresentStatus = typeof ProductRepresentStatus[keyof typeof ProductRepresentStatus];
export type ProductFilter = {
  representStatus?: InputMaybe<ProductRepresentStatus>;
  statuses?: InputMaybe<Array<ProductStatus>>;
  productType?: InputMaybe<ProductType>;
};

export const ProductSortType = {
  Popular: 'POPULAR',
  Recent: 'RECENT'
} as const;

export type ProductSortType = typeof ProductSortType[keyof typeof ProductSortType];
export const ProductType = {
  Goods: 'GOODS',
  Service: 'SERVICE'
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];
export const ProductDeliveryInfoType = {
  /** 일반 배송 */
  Normal: 'NORMAL',
  /** 당일 배송 */
  SameDay: 'SAME_DAY',
  /** 지원되지 않는 타입 */
  Unknown: 'UNKNOWN'
} as const;

export type ProductDeliveryInfoType = typeof ProductDeliveryInfoType[keyof typeof ProductDeliveryInfoType];
export type ProductDeliveryInfo = {
  __typename?: 'ProductDeliveryInfo';
  /**
   * 배송비
   * 무료배송의 경우 0원
   */
  fee: Scalars['Int'];
  /** 무료 배송 조건 금액 */
  freeConditionPrice: Scalars['Int'];
  /** 배송 타입 */
  type: ProductDeliveryInfoType;
};

export const ProductReceiveMethod = {
  Delivery: 'DELIVERY',
  Pickup: 'PICKUP'
} as const;

export type ProductReceiveMethod = typeof ProductReceiveMethod[keyof typeof ProductReceiveMethod];
export const ProductStatus = {
  Active: 'ACTIVE',
  Banned: 'BANNED',
  Inactive: 'INACTIVE',
  Pending: 'PENDING',
  Rejected: 'REJECTED'
} as const;

export type ProductStatus = typeof ProductStatus[keyof typeof ProductStatus];
export type Product = {
  __typename?: 'Product';
  /** 상품 dbId */
  dbId: Scalars['ID'];
  /** 상품 구매 혜택 */
  benefit?: Maybe<Scalars['String']>;
  /** 상품 본문 */
  content: Scalars['String'];
  /**
   * 상품 할인 금액
   * price - salePrice 와 동일
   */
  discount?: Maybe<Money>;
  /** 최소 주문 금액 */
  minConditionPrice?: Maybe<Money>;
  /** 상품 이름 */
  name: Scalars['String'];
  /** 해당 상품이 당근 공식 스토어에서 생성한 상품인지에 대한 여부 */
  official: Scalars['Boolean'];
  /** 수량 부족 */
  outOfStock: Scalars['Boolean'];
  /** 상품의 원가 */
  price: Money;
  /** 상품의 판매 가격 */
  salePrice: Money;
  /** 상품의 타입 */
  productType: ProductType;
  /** 상품의 수령 방식 */
  receiveMethods: Array<ProductReceiveMethod>;
  /** 대표 상품인지에 대한 여부 */
  isRepersent: Scalars['Boolean'];
  /** 판매된 수량 */
  sold: Scalars['Int'];
  /** 상품의 상태 */
  status: ProductStatus;
  /**
   * 상품 수량
   * 제한 없이 설정될 수 있음
   */
  stock?: Maybe<Scalars['Int']>;
  /**
   * 상품 수량 제한 해제 여부
   * true인 경우 stock 은 null
   */
  stockFree: Scalars['Boolean'];
  /** 상품을 생성한 비즈프로필 */
  businessProfile?: Maybe<LocalProfile>;
  /** 상품의 썸네일 이미지 목록 */
  images: Array<Scalars['String']>;
  /** 상품의 후기 수 */
  reviewCount: Scalars['Int'];
  /** 상품의 관심 수 */
  watchCount: Scalars['Int'];
  /**
   * 배송 설정 관련 정보
   * GOODS 타입 상품에서만 존재
   */
  deliveryInfo?: Maybe<ProductDeliveryInfo>;
};

export type BusinessProfileFeatures = {
  __typename?: 'BusinessProfileFeatures';
  post: Scalars['Boolean'];
  /** 소식의 댓글기능이에요. false이면 소식의 댓글 영역 UI가 미노출 돼야하고, "댓글 수" UI도 미노출 돼야해요 */
  postComment: Scalars['Boolean'];
  postEditor: Scalars['Boolean'];
  /** 블로그형 에디터를 통한 소식생성시 이미지 개수 제한을 풀어요. 퍼머링크에선 고려할 필요 없을 거 같아요. */
  postEditorBlogImageNoLimit: Scalars['Boolean'];
  follow: Scalars['Boolean'];
  /** 단골버튼 알림을 on/off 할지 정하는 거예요. */
  followNotification: Scalars['Boolean'];
  coupon: Scalars['Boolean'];
  /** 후기 기능을 on/off해요. false이면 후기 작성 버튼 미노출, 후기 관련 UI(후기 탭, 후기 섹션 등) 미노출, 후기 수 미노출해요. */
  review: Scalars['Boolean'];
  /** 채팅 기능을 on/off해요. false이면 채팅하기 버튼(홈, 소식상세) 미노출해요. */
  chat: Scalars['Boolean'];
  /** 리전이 없는 경우가 있어요(브랜드프로필, 멘데터리 프로필 등). false이면 지역명 텍스트를 미노출, 지도 미노출, 주소정보 미노출해요. */
  region: Scalars['Boolean'];
  /** true이면 브랜드프로필이나 공식프로필의 경우 붙여주는 오피셜 뱃지 UI를 추가해요. */
  officialBadge: Scalars['Boolean'];
  /** 커머스 스토어 관련 기능을 on/off해요. false이면 상품탭을 보여주지 않아요. */
  store: Scalars['Boolean'];
  reservation: Scalars['Boolean'];
};

/** BusinessProfile 의 카테고리 정보 */
export type BusinessCategory = {
  __typename?: 'BusinessCategory';
  name: Scalars['String'];
  levels: Array<Scalars['String']>;
};

/** BusinessProfile 의 상태 */
export const BusinessProfileStatus = {
  Pending: 'PENDING',
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type BusinessProfileStatus = typeof BusinessProfileStatus[keyof typeof BusinessProfileStatus];
/** BusinessProfile 의 타입 */
export const BusinessProfileType = {
  /** 기본 비즈프로필 타입 */
  Default: 'DEFAULT',
  /** 레거시 */
  Individual: 'INDIVIDUAL',
  /**
   * 미니앱 광고 집행을 위한 비즈프로필 타입 (a.k.a. 위젯프로필)
   * ex. 남의집
   */
  Widget: 'WIDGET',
  /**
   * 강제로 모든 비즈프로필이 단골로 맺어지는 비즈프로필. 그 외 OFFICIAL과 동일
   * ex. 당근 사장님 학교
   */
  Mandatory: 'MANDATORY',
  /**
   * 당근 공식 계정 (채팅, 후기 제거)
   * ex. 당근공식스토어
   */
  Official: 'OFFICIAL',
  /**
   * 지역 기반의 가게가 아닌, 브랜드를 표현하기 위한 비즈프로필 타입
   * ex. 베스킨라빈스
   */
  Brand: 'BRAND',
  Unknown: 'UNKNOWN'
} as const;

export type BusinessProfileType = typeof BusinessProfileType[keyof typeof BusinessProfileType];
export const BusinessProfileHolidayType = {
  /** 모든 공휴일 (일요일 제외) */
  All: 'ALL',
  /** 설날, 추석 */
  GreatHoliday: 'GREAT_HOLIDAY'
} as const;

export type BusinessProfileHolidayType = typeof BusinessProfileHolidayType[keyof typeof BusinessProfileHolidayType];
export type BusinessProfileCloseDays = {
  __typename?: 'BusinessProfileCloseDays';
  holidayType?: Maybe<BusinessProfileHolidayType>;
};

export type BusinessProfileBusinessDayBreakHours = {
  __typename?: 'BusinessProfileBusinessDayBreakHours';
  /** 영업 시작 시간 */
  from: Scalars['String'];
  /** 영업 종료 시간 */
  to: Scalars['String'];
};

export type BusinessProfileOperationInfo = {
  /** 휴식 시작/종료 시간 */
  breakHours?: Maybe<BusinessProfileBusinessDayBreakHours>;
  /** 영업 시작/종료 시간 */
  hours?: Maybe<BusinessProfileBusinessDayBreakHours>;
  /** 24시간 영업점인지에 대한 정보 */
  open24Hours: Scalars['Boolean'];
};

export type BusinessProfileBusinessDay = BusinessProfileOperationInfo & {
  __typename?: 'BusinessProfileBusinessDay';
  breakHours?: Maybe<BusinessProfileBusinessDayBreakHours>;
  /** 영업 종료 상태인지에 대한 정보 */
  closed: Scalars['Boolean'];
  hours?: Maybe<BusinessProfileBusinessDayBreakHours>;
  open24Hours: Scalars['Boolean'];
};

export type BusinessProfileWeeklyBusinessDays = {
  __typename?: 'BusinessProfileWeeklyBusinessDays';
  monday: BusinessProfileBusinessDay;
  tuesday: BusinessProfileBusinessDay;
  wednesday: BusinessProfileBusinessDay;
  thursday: BusinessProfileBusinessDay;
  friday: BusinessProfileBusinessDay;
  saturday: BusinessProfileBusinessDay;
  sunday: BusinessProfileBusinessDay;
};

export type BusinessProfileWeeklyUpcomingBusinessDays = {
  __typename?: 'BusinessProfileWeeklyUpcomingBusinessDays';
  monday: BusinessProfileUpcomingBusinessDay;
  tuesday: BusinessProfileUpcomingBusinessDay;
  wednesday: BusinessProfileUpcomingBusinessDay;
  thursday: BusinessProfileUpcomingBusinessDay;
  friday: BusinessProfileUpcomingBusinessDay;
  saturday: BusinessProfileUpcomingBusinessDay;
  sunday: BusinessProfileUpcomingBusinessDay;
};

export const BusinessProfileDailyOperationInfoStatus = {
  /** 영업일 */
  Open: 'OPEN',
  /** 임시 영업일 */
  TemporarilyOpen: 'TEMPORARILY_OPEN',
  /** 정기 휴무일 */
  RegularlyClosed: 'REGULARLY_CLOSED',
  /** 임시 휴무일 */
  TemporarilyClosed: 'TEMPORARILY_CLOSED',
  /** 공휴일 */
  HolidayClosed: 'HOLIDAY_CLOSED',
  /** 기타 */
  NotCreated: 'NOT_CREATED'
} as const;

export type BusinessProfileDailyOperationInfoStatus = typeof BusinessProfileDailyOperationInfoStatus[keyof typeof BusinessProfileDailyOperationInfoStatus];
export type BusinessProfileHolidayInfo = {
  __typename?: 'BusinessProfileHolidayInfo';
  /** 공휴일 여부 */
  greatHoliday?: Maybe<Scalars['Boolean']>;
  /** 공휴일 이름 */
  name?: Maybe<Scalars['String']>;
};

export type BusinessProfileDailyOperationInfo = {
  __typename?: 'BusinessProfileDailyOperationInfo';
  /** 쉬는 공휴일 정보 */
  closingHoliday?: Maybe<BusinessProfileHolidayInfo>;
  /** 당일 영업 상태 */
  status: BusinessProfileDailyOperationInfoStatus;
};

export type BusinessProfileUpcomingBusinessDay = BusinessProfileOperationInfo & {
  __typename?: 'BusinessProfileUpcomingBusinessDay';
  date: Scalars['String'];
  /** 영업 시간 정보 */
  dailyOperationInfo: BusinessProfileDailyOperationInfo;
  breakHours?: Maybe<BusinessProfileBusinessDayBreakHours>;
  hours?: Maybe<BusinessProfileBusinessDayBreakHours>;
  open24Hours: Scalars['Boolean'];
};

export type BusinessProfileBusinessDayDateRange = {
  __typename?: 'BusinessProfileBusinessDayDateRange';
  /** 영업 시작 시간 */
  from: Scalars['String'];
  /** 영업 종료 시간 */
  to: Scalars['String'];
};

export type BusinessProfileUpcomingClosingInfo = {
  __typename?: 'BusinessProfileUpcomingClosingInfo';
  dailyOperationInfo: BusinessProfileDailyOperationInfo;
  dateRange: BusinessProfileBusinessDayDateRange;
};

export type UpcomingWeeklyBusinessTime = {
  __typename?: 'UpcomingWeeklyBusinessTime';
  businessTimeMap: BusinessProfileWeeklyUpcomingBusinessDays;
  closingInfo?: Maybe<Array<BusinessProfileUpcomingClosingInfo>>;
};

export type BusinessProfileOperationTime = {
  __typename?: 'BusinessProfileOperationTime';
  /** 영업을 하지 않는 날에 대한 정보 */
  closeDays?: Maybe<BusinessProfileCloseDays>;
  /** 요일별 영업 시간 정보 */
  businessDays?: Maybe<BusinessProfileWeeklyBusinessDays>;
  /** 다가오는 일주일에 대한 영업 시간 정보 */
  upcomingWeeklyBusinessTime?: Maybe<UpcomingWeeklyBusinessTime>;
  /** 영업 시간 관련 추가 정보 */
  extra?: Maybe<Scalars['String']>;
  /** 해당일이 영업일인지에 대한 정보 */
  isTodayBusinessDay?: Maybe<Scalars['Boolean']>;
  /** 해당일이 영업일이 아닌지에 대한 정보 */
  isTodayCloseDayOfWeek?: Maybe<Scalars['Boolean']>;
  /** 해당일이 추석/설날과 같은 공휴일인지에 대한 정보 */
  isTodayGreatHoliday?: Maybe<Scalars['Boolean']>;
  /** 해당일이 휴일인지에 대한 정보 */
  isTodayHoliday?: Maybe<Scalars['Boolean']>;
};

export type LocalProfileAddress = {
  __typename?: 'LocalProfileAddress';
  /** 비즈프로필 지번 주소 */
  jibun?: Maybe<Scalars['String']>;
  /** 비즈프로필 지번 주소 */
  road?: Maybe<Scalars['String']>;
  /** 비즈프로필의 상세 주소 */
  extra?: Maybe<Scalars['String']>;
};

export const BusinessProfileStoreStatus = {
  Pending: 'PENDING',
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Blocked: 'BLOCKED',
  Deleted: 'DELETED',
  Rejected: 'REJECTED',
  Unknown: 'UNKNOWN'
} as const;

export type BusinessProfileStoreStatus = typeof BusinessProfileStoreStatus[keyof typeof BusinessProfileStoreStatus];
export type BusinessProfileStore = {
  __typename?: 'BusinessProfileStore';
  id: Scalars['ID'];
  /** Database ID */
  dbId: Scalars['String'];
  status: BusinessProfileStoreStatus;
  /** 스토어의 상품 목록 */
  products: Array<Product>;
};

export const BusinessPricingPriceKind = {
  Fixed: 'FIXED',
  Flexible: 'FLEXIBLE',
  Unfixed: 'UNFIXED'
} as const;

export type BusinessPricingPriceKind = typeof BusinessPricingPriceKind[keyof typeof BusinessPricingPriceKind];
export type BusinessPricing = {
  __typename?: 'BusinessPricing';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isRepresentative: Scalars['Boolean'];
  orderNumber?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  maxPrice?: Maybe<Scalars['Int']>;
  priceKind: BusinessPricingPriceKind;
};

export type BusinessPricingPicture = {
  __typename?: 'BusinessPricingPicture';
  id: Scalars['ID'];
  thumbnail?: Maybe<Scalars['String']>;
  pictureId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Count = {
  __typename?: 'Count';
  watchCount: Scalars['Int'];
  reviewCount: Scalars['Int'];
  reviewStarRating: Scalars['Float'];
  followerCount: Scalars['Int'];
};

export type Pricing = {
  __typename?: 'Pricing';
  /** 가격 정보 */
  pricings: Array<BusinessPricing>;
  /** 가격 사진 정보 */
  pictures: Array<BusinessPricingPicture>;
};

export type BusinessProduct = {
  __typename?: 'BusinessProduct';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  price: BusinessProductPrice;
  salePrice?: Maybe<BusinessProductPrice>;
  thumbnails: Array<Thumbnail>;
  canBeDelivered?: Maybe<Scalars['Boolean']>;
  isFreeDelivery?: Maybe<Scalars['Boolean']>;
  isSameDayDelivery?: Maybe<Scalars['Boolean']>;
};

export type BusinessProductPrice = {
  __typename?: 'BusinessProductPrice';
  amount: Scalars['Int'];
  currency: MoneyCurrency;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  oldImageID?: Maybe<Scalars['String']>;
};

export const CouponStatus = {
  /** 비활성화 된 쿠폰 */
  Inactive: 'INACTIVE',
  /** 활성화 된 쿠폰 */
  Active: 'ACTIVE',
  /** 관리자에 의해 제재된 경우 */
  Forbidden: 'FORBIDDEN',
  /** ??? */
  UnknownStatus: 'UNKNOWN_STATUS',
  /** 발행자가 비활성화 상태 */
  IssuerNotActive: 'ISSUER_NOT_ACTIVE',
  /** 발행자가 제거된 경우 */
  IssuerDeleted: 'ISSUER_DELETED'
} as const;

export type CouponStatus = typeof CouponStatus[keyof typeof CouponStatus];
export const CouponEventType = {
  /** 모든 유저가 발급 받을 수 있는 조건 */
  Normal: 'NORMAL',
  /** 단골만 발급 받을 수 있는 조건 */
  FollowerOnly: 'FOLLOWER_ONLY',
  /** 대응이 되지 않은 타입 */
  UnknownEvent: 'UNKNOWN_EVENT',
  /** 타게팅 쿠폰 */
  TargetOnly: 'TARGET_ONLY'
} as const;

export type CouponEventType = typeof CouponEventType[keyof typeof CouponEventType];
export const CouponCondition = {
  /** 쿠폰 다운 가능 */
  Available: 'AVAILABLE',
  /** 쿠폰 비활성화 상태 */
  NotActive: 'NOT_ACTIVE',
  /** 쿠폰 만료 */
  Expired: 'EXPIRED',
  /** 쿠폰 수량 부족 */
  LackOfQuantit: 'LACK_OF_QUANTIT',
  /** 예외적인 조건 */
  UnknownCondition: 'UNKNOWN_CONDITION'
} as const;

export type CouponCondition = typeof CouponCondition[keyof typeof CouponCondition];
export type Coupon = {
  __typename?: 'Coupon';
  /** 쿠폰 생성 시점 */
  createdAt: Scalars['String'];
  /** 쿠폰 수정 시점 */
  updatedAt: Scalars['String'];
  /** 쿠폰 만료 시점 */
  expiresAt?: Maybe<Scalars['String']>;
  /** 쿠폰 이름 */
  name: Scalars['String'];
  /** 쿠폰 상태 */
  status: CouponStatus;
  /** 쿠폰 다운받은 수량 */
  claimedCount: Scalars['Int'];
  /**
   * 쿠폰 발행 수량
   * 제한 없이 발행 가능
   */
  issuedCount?: Maybe<Scalars['Int']>;
  /** 쿠폰 사용 수량 */
  usedCount: Scalars['Int'];
  /** 쿠폰 발급 관련 상태 */
  couponCondition: CouponCondition;
  /** 쿠폰 발급 관련 조건 타입 */
  eventType: CouponEventType;
  /** 쿠폰 설명 */
  description: Scalars['String'];
  /** 쿠폰 발급 지역 */
  region?: Maybe<Region>;
};

export type BusinessVefification = {
  __typename?: 'BusinessVefification';
  verified: Scalars['Boolean'];
  licenses: Array<License>;
};

export const MetaType = {
  Text: 'TEXT',
  Image: 'IMAGE',
  Link: 'LINK'
} as const;

export type MetaType = typeof MetaType[keyof typeof MetaType];
export type Meta = {
  __typename?: 'Meta';
  type?: Maybe<MetaType>;
  caption?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type License = {
  __typename?: 'License';
  label?: Maybe<Scalars['String']>;
  meta?: Maybe<Array<Meta>>;
};

export type BusinessAccount = {
  __typename?: 'BusinessAccount';
  baId?: Maybe<Scalars['Int']>;
  status?: Maybe<BusinessProfileStoreStatus>;
};

export type LastAccess = {
  __typename?: 'LastAccess';
  lastAccessedAt?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
};

export type BusinessReviewProfile = {
  __typename?: 'BusinessReviewProfile';
  id?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  regionCheckinsCount?: Maybe<Scalars['Int']>;
};

export type BusinessReviewActorRegion = {
  __typename?: 'BusinessReviewActorRegion';
  name?: Maybe<Scalars['String']>;
};

export const BusinessResourceType = {
  BusinessAccount: 'BUSINESS_ACCOUNT'
} as const;

export type BusinessResourceType = typeof BusinessResourceType[keyof typeof BusinessResourceType];
export type BusinessReview = {
  __typename?: 'BusinessReview';
  content: Scalars['String'];
  extend: ReviewExtend;
  user: BusinessReviewProfile;
  actorRegion: BusinessReviewActorRegion;
  images: Array<LocalProfileImage>;
  starRating: Scalars['Float'];
  tags: Array<Tag>;
  likesCount: Scalars['Int'];
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  deleted: Scalars['Boolean'];
  reported: Scalars['Boolean'];
  blocked: Scalars['Boolean'];
  postStopped: Scalars['Boolean'];
  reviewerInfo: ReviewerInfo;
  comment?: Maybe<ReviewComment>;
};

export type ReviewExtend = {
  __typename?: 'ReviewExtend';
  productName?: Maybe<Scalars['String']>;
  reviewCount?: Maybe<Scalars['Int']>;
};

export type Tag = {
  __typename?: 'Tag';
  content: Scalars['String'];
};

export type LocalProfileImage = {
  __typename?: 'LocalProfileImage';
  url: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  mediumUrl: Scalars['String'];
};

export type ReviewerInfo = {
  __typename?: 'ReviewerInfo';
  likedByMe: Scalars['Boolean'];
  followBusinessAccount: Scalars['Boolean'];
};

export type ReviewComment = {
  __typename?: 'ReviewComment';
  id: Scalars['Int'];
  content: Scalars['String'];
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

/** BusinessProfile 상세 정보 */
export type LocalProfile = Node & {
  __typename?: 'LocalProfile';
  id: Scalars['ID'];
  ownerBa?: Maybe<BusinessAccount>;
  targetUri: Scalars['String'];
  backgroundPictures: Array<Scalars['String']>;
  availableServiceFieldNames: Array<Scalars['String']>;
  address?: Maybe<LocalProfileAddress>;
  /** 홈페이지 */
  url?: Maybe<Scalars['String']>;
  /** 문의 전화 번호 */
  phone?: Maybe<Scalars['String']>;
  /** 안심 번호 */
  safeNumber?: Maybe<Scalars['String']>;
  additionalInformation?: Maybe<Array<Scalars['String']>>;
  notice?: Maybe<Scalars['String']>;
  promotion?: Maybe<Scalars['String']>;
  count: Count;
  businessVerification?: Maybe<BusinessVefification>;
  /** 업무 일, 시간 관련 설정 */
  operationTime?: Maybe<BusinessProfileOperationTime>;
  /** 비즈프로필 이름 */
  name: Scalars['String'];
  /** 비즈프로필 소개 */
  description: Scalars['String'];
  /** 비즈프로필 프로필 이미지 썸네일 */
  thumbImageUrl?: Maybe<Scalars['String']>;
  /** 비즈프로필 지역 */
  regionId?: Maybe<Region>;
  /** 비즈프로필 카테고리 */
  category?: Maybe<BusinessCategory>;
  /** 비즈프로필 상태 */
  status: BusinessProfileStatus;
  /** 비즈프로필 예약 v1 가능 여부 */
  supportReservation: Scalars['Boolean'];
  /** 비즈프로필 예약 v2 가능 여부 */
  supportReservationV2: Scalars['Boolean'];
  /** 위경도 좌표 */
  coordinates?: Maybe<BusinessProfileCoordinates>;
  /** 비즈프로필의 타입 */
  baType?: Maybe<BusinessProfileType>;
  /** 해당 비즈프로필의 소식 목록 */
  bizPostIds: Array<BusinessPost>;
  /** 해당 비즈프로필의 쿠폰 목록 */
  coupons: Array<Coupon>;
  /** 비즈프로필의 후기 목록 */
  reviews: Array<BusinessReview>;
  pricing?: Maybe<Pricing>;
  /** 비즈프로필의 메뉴 목록 */
  features?: Maybe<BusinessProfileFeatures>;
  products: Array<BusinessProduct>;
  lastAccess?: Maybe<LastAccess>;
  editedAt: Scalars['String'];
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CarData = {
  __typename?: 'CarData';
  /** 차종 */
  carType: CarType;
  /** 제조사 */
  companyName?: Maybe<Scalars['String']>;
  /** 차량명 */
  carName: Scalars['String'];
  /** 연식 */
  modelYear: Scalars['Int'];
  /** 차량 최초 등록 연도 */
  carRegistrationYear?: Maybe<Scalars['Int']>;
  /** 차량 최초 등록 월 */
  carRegistrationMonth?: Maybe<Scalars['Int']>;
  /** 연로 타입 */
  fuelType?: Maybe<FuelType>;
  /** 변속기 종류 */
  gear: Gear;
  /** 옵션: CarOptionName */
  options: Scalars['String'];
  /** 카히스토리 정보 */
  carHistory?: Maybe<CarHistory>;
};

export type CarHistory = {
  __typename?: 'CarHistory';
  accidentsCount?: Maybe<Scalars['Int']>;
  businessUsage?: Maybe<Scalars['String']>;
  ownerChangeCount?: Maybe<Scalars['Int']>;
};

export type LeaseRentalInfo = {
  __typename?: 'LeaseRentalInfo';
  /** 월 이용료 */
  monthlyFee?: Maybe<Scalars['Int']>;
  /** 리스/렌트 시작일 */
  contractStartedAt: Scalars['String'];
  /** 렌트 종료일 */
  contractEndedAt: Scalars['String'];
  /** 잔존가치 */
  residualValue: Scalars['Int'];
  /** 인수금 */
  acquisitionPrice: Scalars['Int'];
  /** 만기 후 처리 */
  postContractOption: PostContractOption;
  /** 보증금 */
  deposit: Scalars['Int'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export const CarPostType = {
  Sale: 'SALE',
  Rental: 'RENTAL',
  Lease: 'LEASE'
} as const;

export type CarPostType = typeof CarPostType[keyof typeof CarPostType];
export const CarType = {
  Small: 'SMALL',
  Middle: 'MIDDLE',
  Big: 'BIG',
  Suv: 'SUV',
  Business: 'BUSINESS',
  Etc: 'ETC'
} as const;

export type CarType = typeof CarType[keyof typeof CarType];
export const FuelType = {
  Gasoline: 'GASOLINE',
  GasolineElectronic: 'GASOLINE_ELECTRONIC',
  Diesel: 'DIESEL',
  DieselElectronic: 'DIESEL_ELECTRONIC',
  Lpg: 'LPG',
  LpgGasoline: 'LPG_GASOLINE',
  LpgElectronic: 'LPG_ELECTRONIC',
  Cng: 'CNG',
  Electronic: 'ELECTRONIC',
  FuelCellElectronic: 'FUEL_CELL_ELECTRONIC',
  Hybrid: 'HYBRID',
  H2OElectronic: 'H2O_ELECTRONIC',
  Unknown: 'UNKNOWN'
} as const;

export type FuelType = typeof FuelType[keyof typeof FuelType];
export const Gear = {
  Auto: 'AUTO',
  Manual: 'MANUAL',
  SemiAuto: 'SEMI_AUTO',
  Cvt: 'CVT',
  Unknown: 'UNKNOWN'
} as const;

export type Gear = typeof Gear[keyof typeof Gear];
export const CarOptionName = {
  /** 가죽시트 */
  LeatherSeat: 'LEATHER_SEAT',
  /** 전동시트 */
  PowerSeat: 'POWER_SEAT',
  /** 통풍시트 */
  VentilatedSeat: 'VENTILATED_SEAT',
  /** 열선시트 */
  HeatedSeat: 'HEATED_SEAT',
  /** 열선스티어링휠 */
  HeatedSteeringWheel: 'HEATED_STEERING_WHEEL',
  /** 선루프 */
  Sunroof: 'SUNROOF',
  /** 파노라마 선루프 */
  PanoramaSunroof: 'PANORAMA_SUNROOF',
  /** 헤드램프 */
  Headlamp: 'HEADLAMP',
  /** 전동 트렁크 */
  AutoTrunk: 'AUTO_TRUNK',
  /** 전동 접이식 미러 */
  AutoFoldingSideMirror: 'AUTO_FOLDING_SIDE_MIRROR',
  /** 하이패스 */
  Hipass: 'HIPASS',
  /** 주차 센서 전방 */
  ParkSensorFront: 'PARK_SENSOR_FRONT',
  /** 주차 센서 후방 */
  ParkSensorRear: 'PARK_SENSOR_REAR',
  /** 후방 카메라 */
  RearCamera: 'REAR_CAMERA',
  /** 어라운드 뷰 */
  AroundView: 'AROUND_VIEW',
  /**
   * 차선 이탈 경보
   * Lane Departure Warning System
   */
  Ldws: 'LDWS',
  /**
   * 후측방 경보
   * Blind Spot Detection
   */
  Bsd: 'BSD',
  /**
   * 긴급 제동
   * Auto Emergency Braking
   */
  Aeb: 'AEB',
  /**
   * 타이어 공기압 센서
   * Tire Pressure Monitor System
   */
  Tpms: 'TPMS',
  /** 블루투스 */
  Bluetooth: 'BLUETOOTH',
  /** 네비게이션 */
  Navigation: 'NAVIGATION',
  /** 스마트키 */
  SmartKey: 'SMART_KEY',
  /** 크루즈 컨트롤 */
  CruiseControl: 'CRUISE_CONTROL',
  /** 자동 에어컨 */
  AutoAirConditioner: 'AUTO_AIR_CONDITIONER',
  /** 자동 와이퍼 */
  AutoWiper: 'AUTO_WIPER',
  /** 헤드업 디스플레이 */
  Hud: 'HUD',
  /**
   * 전자식 주차 브레이크
   * Electronic Parking Brake
   */
  Epb: 'EPB',
  /**
   * 자동차키 2개
   * (기본 1개)
   */
  NumOfKey_2: 'NUM_OF_KEY_2',
  /** 블랙박스 */
  DashboardCamera: 'DASHBOARD_CAMERA',
  /** 금연 */
  SmokingFree: 'SMOKING_FREE'
} as const;

export type CarOptionName = typeof CarOptionName[keyof typeof CarOptionName];
export const PostContractOption = {
  BuyOrReturn: 'BUY_OR_RETURN',
  Buy: 'BUY',
  Return: 'RETURN'
} as const;

export type PostContractOption = typeof PostContractOption[keyof typeof PostContractOption];
export const CarPostStatus = {
  None: 'NONE',
  OnSale: 'ON_SALE',
  Reserved: 'RESERVED',
  Traded: 'TRADED'
} as const;

export type CarPostStatus = typeof CarPostStatus[keyof typeof CarPostStatus];
export type CarPost = Node & {
  __typename?: 'CarPost';
  id: Scalars['ID'];
  type: CarPostType;
  driveDistance: Scalars['Int'];
  content: Scalars['String'];
  status: CarPostStatus;
  price: Scalars['Int'];
  coordinate?: Maybe<Coordinates>;
  user?: Maybe<KarrotUser>;
  recommendedCarPosts: Array<CarPost>;
  region: Region;
  carData: CarData;
  images: Array<Scalars['String']>;
  /** 배기량 */
  displacement?: Maybe<Scalars['Int']>;
  /** 리스/렌트 정보 */
  leaseRentalInfo?: Maybe<LeaseRentalInfo>;
  /** 조회수 */
  viewCount: Scalars['Int'];
  /** 채팅수 */
  chatRoomCount: Scalars['Int'];
  /** 관심수 */
  voteCount: Scalars['Int'];
  publishedAt: Scalars['String'];
  isInspected: Scalars['Boolean'];
  isWarrantable: Scalars['Boolean'];
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CarAllPage = Node & {
  __typename?: 'CarAllPage';
  id: Scalars['ID'];
  carPosts: Array<CarPost>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export const SalaryType = {
  Monthly: 'MONTHLY',
  Daily: 'DAILY',
  Hourly: 'HOURLY',
  PerCase: 'PER_CASE'
} as const;

export type SalaryType = typeof SalaryType[keyof typeof SalaryType];
export const SalaryPayMethod = {
  WorkDayPayment: 'WORK_DAY_PAYMENT'
} as const;

export type SalaryPayMethod = typeof SalaryPayMethod[keyof typeof SalaryPayMethod];
export const Day = {
  Mon: 'MON',
  Tue: 'TUE',
  Wed: 'WED',
  Thu: 'THU',
  Fri: 'FRI',
  Sat: 'SAT',
  Sun: 'SUN'
} as const;

export type Day = typeof Day[keyof typeof Day];
export const Badge = {
  FastResponse: 'FAST_RESPONSE',
  PerfectAuthor: 'PERFECT_AUTHOR'
} as const;

export type Badge = typeof Badge[keyof typeof Badge];
export type WorkplaceLocation = {
  __typename?: 'WorkplaceLocation';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type JobPost = Node & {
  __typename?: 'JobPost';
  id: Scalars['ID'];
  title: Scalars['String'];
  appSchemePath: Scalars['String'];
  author?: Maybe<KarrotUser>;
  content: Scalars['String'];
  images: Array<Scalars['String']>;
  closed: Scalars['Boolean'];
  workplaceCompanyName?: Maybe<Scalars['String']>;
  workplaceLocation?: Maybe<WorkplaceLocation>;
  workplaceRegion?: Maybe<Region>;
  workplaceLotNumberAddress?: Maybe<Scalars['String']>;
  workplaceRoadNameAddress?: Maybe<Scalars['String']>;
  salaryType: SalaryType;
  salary: Scalars['Int'];
  workDates: Array<Scalars['String']>;
  workDays: Array<Day>;
  workTimeStart: Scalars['String'];
  workTimeEnd: Scalars['String'];
  isWorkTimeNegotiable?: Maybe<Scalars['Boolean']>;
  recommendedJobPosts: Array<JobPost>;
  acceptedAt?: Maybe<Scalars['String']>;
  applicationCount: Scalars['Int'];
  watchCount: Scalars['Int'];
  reviewCount: Scalars['Int'];
  badges: Array<Badge>;
  salaryPayMethod?: Maybe<SalaryPayMethod>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type JobsAllPage = Node & {
  __typename?: 'JobsAllPage';
  id: Scalars['ID'];
  jobPosts: Array<JobPost>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export const BuildingUsageEnum = {
  /** 숙박시설 */
  AccommodationFacility: 'ACCOMMODATION_FACILITY',
  /** 방송통신시설 */
  BroadcastingAndCommunicationFacility: 'BROADCASTING_AND_COMMUNICATION_FACILITY',
  /** 자동차관련시설 */
  CarRelatedFacility: 'CAR_RELATED_FACILITY',
  /** 묘지관련시설 */
  CemeteryRelatedFacility: 'CEMETERY_RELATED_FACILITY',
  /** 교정및군사시설 */
  CorrectionAndMilitaryFacility: 'CORRECTION_AND_MILITARY_FACILITY',
  /** 문화 및 집회시설 */
  CulturalAndAssemblyFacilities: 'CULTURAL_AND_ASSEMBLY_FACILITIES',
  /** 동식물관련시설 */
  DoorAndPlantRelatedFacility: 'DOOR_AND_PLANT_RELATED_FACILITY',
  /** 교육연구시설 */
  EducationAndResearchFacility: 'EDUCATION_AND_RESEARCH_FACILITY',
  /** 노유자시설 */
  ElderlyFacility: 'ELDERLY_FACILITY',
  /** 운동시설 */
  ExerciseFacility: 'EXERCISE_FACILITY',
  /** 공장 */
  Factory: 'FACTORY',
  /** 장례식장 */
  FuneralHome: 'FUNERAL_HOME',
  /** 위험물저장및처리시설 */
  HazardousMaterialFacility: 'HAZARDOUS_MATERIAL_FACILITY',
  /** 의료시설 */
  MedicalFacility: 'MEDICAL_FACILITY',
  /** 업무시설 */
  OfficeFacility: 'OFFICE_FACILITY',
  /** 발전시설 */
  PowerGenerationFacility: 'POWER_GENERATION_FACILITY',
  /** 공동주택 */
  PublicHousing: 'PUBLIC_HOUSING',
  /** 위락시설 */
  RecreationFacility: 'RECREATION_FACILITY',
  /** 종교시설 */
  ReligiousFacility: 'RELIGIOUS_FACILITY',
  /** 판매시설 */
  SaleFacility: 'SALE_FACILITY',
  /** 분뇨쓰레기처리시설 */
  SewageAndWasteProcessingFacility: 'SEWAGE_AND_WASTE_PROCESSING_FACILITY',
  /** 단독주택 */
  SingleFamilyHousing: 'SINGLE_FAMILY_HOUSING',
  /** 수련시설 */
  StudyFacility: 'STUDY_FACILITY',
  /** 가설건축물 */
  TemporaryBuilding: 'TEMPORARY_BUILDING',
  /** 관광휴게시설 */
  TourismAndRecreationFacility: 'TOURISM_AND_RECREATION_FACILITY',
  /** 운수시설 */
  TransportationFacility: 'TRANSPORTATION_FACILITY',
  /** 제1종 근린생활시설 */
  Type_1NeighborhoodLivingFacility: 'TYPE_1_NEIGHBORHOOD_LIVING_FACILITY',
  /** 제2종 근린생활시설 */
  Type_2NeighborhoodLivingFacility: 'TYPE_2_NEIGHBORHOOD_LIVING_FACILITY',
  /** 창고시설 */
  WarehouseFacility: 'WAREHOUSE_FACILITY'
} as const;

export type BuildingUsageEnum = typeof BuildingUsageEnum[keyof typeof BuildingUsageEnum];
export const ArticleBuildingOrientationEnum = {
  /** 남향 */
  SouthFacing: 'SOUTH_FACING',
  /** 동향 */
  EastFacing: 'EAST_FACING',
  /** 서향 */
  WestFacing: 'WEST_FACING',
  /** 북향 */
  NorthFacing: 'NORTH_FACING',
  /** 남동향 */
  SouthEastFacing: 'SOUTH_EAST_FACING',
  /** 남서향 */
  SouthWestFacing: 'SOUTH_WEST_FACING',
  /** 북서향 */
  NorthWestFacing: 'NORTH_WEST_FACING',
  /** 북동향 */
  NorthEastFacing: 'NORTH_EAST_FACING'
} as const;

export type ArticleBuildingOrientationEnum = typeof ArticleBuildingOrientationEnum[keyof typeof ArticleBuildingOrientationEnum];
export type RealtyCoordinates = {
  __typename?: 'RealtyCoordinates';
  lat: Scalars['String'];
  lon: Scalars['String'];
};

export const ArticleTradeType = {
  Borrow: 'BORROW',
  Buy: 'BUY',
  Short: 'SHORT',
  Month: 'MONTH',
  Year: 'YEAR'
} as const;

export type ArticleTradeType = typeof ArticleTradeType[keyof typeof ArticleTradeType];
export type ArticleTrade = {
  __typename?: 'ArticleTrade';
  type: ArticleTradeType;
  preferred: Scalars['Boolean'];
  manageCost?: Maybe<Scalars['Float']>;
  manageCostDescription?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  adjustable?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Int']>;
  monthlyPay?: Maybe<Scalars['Int']>;
  yearlyPay?: Maybe<Scalars['Int']>;
};

/** 매물 옵션 이름 */
export const ArticleOptionNameEnum = {
  /** 에어컨 */
  Aircon: 'AIRCON',
  /** 침대 */
  Bed: 'BED',
  /** 전자레인지 */
  ElecRange: 'ELEC_RANGE',
  /** 엘리베이터 */
  Elevator: 'ELEVATOR',
  /** 냉장고 */
  Fridge: 'FRIDGE',
  /** 가스레인지 */
  GasRange: 'GAS_RANGE',
  /** 인덕션 */
  Induction: 'INDUCTION',
  /** 복층 */
  Loft: 'LOFT',
  /** 대출 */
  Mortgage: 'MORTGAGE',
  /** 주차 */
  Parking: 'PARKING',
  /** 애완동물 */
  Pet: 'PET',
  /** 옥탑 */
  Rooftop: 'ROOFTOP',
  /** 세탁기 */
  Washer: 'WASHER'
} as const;

export type ArticleOptionNameEnum = typeof ArticleOptionNameEnum[keyof typeof ArticleOptionNameEnum];
/** 매물 옵션 값 */
export const ArticleOptionValueEnum = {
  /** 확인 필요 */
  DontKnow: 'DONT_KNOW',
  /** 옵션 해당하지 않음 */
  No: 'NO',
  /** 옵션 해당 */
  Yes: 'YES'
} as const;

export type ArticleOptionValueEnum = typeof ArticleOptionValueEnum[keyof typeof ArticleOptionValueEnum];
export type ArticleOption = {
  __typename?: 'ArticleOption';
  name: ArticleOptionNameEnum;
  value: ArticleOptionValueEnum;
};

/**
 * 작성자 유형
 * 대리인 스펙 적용시점(2025/05/08)부터 `writerType`은 개인 / 공인중개사로만 구분합니다.
 * 따라서 LESSOR, TENANT, DIRECT_USER는 같은 값으로 취급해주세요!
 */
export const WriterTypeEnum = {
  /** 집주인 / 직거래 매물 */
  Lessor: 'LESSOR',
  /** 세입자 / 직거래 매물 */
  Tenant: 'TENANT',
  /** 공인중개사 / 부동산 매물 */
  Broker: 'BROKER',
  /** 개인 / 직거래 매물 */
  DirectUser: 'DIRECT_USER'
} as const;

export type WriterTypeEnum = typeof WriterTypeEnum[keyof typeof WriterTypeEnum];
export const SalesTypeEnum = {
  /** 아파트 */
  Apart: 'APART',
  /** 기타 */
  Etc: 'ETC',
  /** 오피스텔 */
  Officetel: 'OFFICETEL',
  /** 오픈형 원룸 */
  OpenOneRoom: 'OPEN_ONE_ROOM',
  /** 분리형 원룸 */
  SplitOneRoom: 'SPLIT_ONE_ROOM',
  /** 상가 */
  Store: 'STORE',
  /** 투룸 */
  TwoRoom: 'TWO_ROOM'
} as const;

export type SalesTypeEnum = typeof SalesTypeEnum[keyof typeof SalesTypeEnum];
export const RealtyArticleStatusEnum = {
  /** 판매중 */
  OnGoing: 'ON_GOING',
  /** 예약중 */
  Reserved: 'RESERVED',
  /** 거래완료 */
  Traded: 'TRADED'
} as const;

export type RealtyArticleStatusEnum = typeof RealtyArticleStatusEnum[keyof typeof RealtyArticleStatusEnum];
export type Broker = {
  __typename?: 'Broker';
  originalId?: Maybe<Scalars['String']>;
  brokerRegisterNumber?: Maybe<Scalars['String']>;
  officeName?: Maybe<Scalars['String']>;
  brokerName?: Maybe<Scalars['String']>;
  officeAddress?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  logoImageUrl?: Maybe<Scalars['String']>;
};

export const RealtyBrokerBusinessProfileStatusEnum = {
  /** 활성 */
  Active: 'ACTIVE',
  /** 비활성 */
  Inactive: 'INACTIVE',
  /** 심사중 */
  Pending: 'PENDING'
} as const;

export type RealtyBrokerBusinessProfileStatusEnum = typeof RealtyBrokerBusinessProfileStatusEnum[keyof typeof RealtyBrokerBusinessProfileStatusEnum];
export type RealtyBrokerBusinessProfile = {
  __typename?: 'RealtyBrokerBusinessProfile';
  /** Global ID */
  id: Scalars['ID'];
  /** 원본 ID */
  originalId: Scalars['String'];
  /** localProfileId */
  localProfileId: LocalProfile;
  /** 중개사무소 이름(BizProfile 이름) */
  name: Scalars['String'];
  /** 썸네일 URL */
  thumbImageUrl: Scalars['String'];
  /** 비즈프로필 상태 */
  status: RealtyBrokerBusinessProfileStatusEnum;
  /** 사업자 등록번호 */
  businessRegistrationNumber: Scalars['String'];
  /** 중개사무소 등록번호 */
  licenseRegistrationNumber: Scalars['String'];
  /** 중개사무소 등록번호 소유자 연락처 */
  licenseOwnerContact: Scalars['String'];
  /** 중개사무소 등록번호 소유자 이름 */
  licenseOwnerName: Scalars['String'];
  /** 중개사무소 지번 주소 */
  jibunAddress: Scalars['String'];
  /** 중개사무소 도로명 주소 */
  roadAddress: Scalars['String'];
  /** 중개사무소 생성 일자 */
  createdAt: Scalars['String'];
};

export const ArticleManageCostOptionEnum = {
  /** 난방 */
  Boiler: 'BOILER',
  /** 청소 */
  Cleaning: 'CLEANING',
  /** 공용관리비 */
  Common: 'COMMON',
  /** 전기 */
  Electric: 'ELECTRIC',
  /** 엘레베이터 */
  Elevator: 'ELEVATOR',
  /** 기타 */
  Etc: 'ETC',
  /** 가스 */
  Gas: 'GAS',
  /** 인터넷 */
  Internet: 'INTERNET',
  /** 주차 */
  Parking: 'PARKING',
  /** 유선 TV */
  Tv: 'TV',
  /** 수도 */
  Waterworks: 'WATERWORKS'
} as const;

export type ArticleManageCostOptionEnum = typeof ArticleManageCostOptionEnum[keyof typeof ArticleManageCostOptionEnum];
export const ManageCostPayOptionEnum = {
  /** 고정금액 */
  Fixed: 'FIXED',
  /** 확인 필요 */
  NeedToCheck: 'NEED_TO_CHECK',
  /** 쓴 만큼 내는 요금 */
  Used: 'USED',
  /** 관리비 없음 */
  None: 'NONE'
} as const;

export type ManageCostPayOptionEnum = typeof ManageCostPayOptionEnum[keyof typeof ManageCostPayOptionEnum];
export type IncludeManageCostOptionV2 = {
  __typename?: 'IncludeManageCostOptionV2';
  /** 고정 관리비 금액 */
  fixedCost?: Maybe<Scalars['Float']>;
  /** 관리비 옵션 */
  option: ArticleManageCostOptionEnum;
  /** 관리비 지불 방식 */
  payOption?: Maybe<ManageCostPayOptionEnum>;
};

export type IncludeManageCostOptionV3 = {
  __typename?: 'IncludeManageCostOptionV3';
  /** 고정 관리비 금액 */
  fixedCost?: Maybe<Scalars['Float']>;
  /** 관리비 옵션 */
  option: ArticleManageCostOptionEnum;
  /** 관리비 지불 방식 */
  payOption?: Maybe<ManageCostPayOptionEnum>;
  /** option이 ETC일 경우 직접 입력한 항목명 */
  customOptionName?: Maybe<Scalars['String']>;
};

/** 관리비 부과 타입 */
export const ManageCostChargeTypeEnum = {
  /** 기타 */
  Etc: 'ETC',
  /** 정액 */
  Fixed: 'FIXED',
  /** 확인 불가 */
  Unavailable: 'UNAVAILABLE'
} as const;

export type ManageCostChargeTypeEnum = typeof ManageCostChargeTypeEnum[keyof typeof ManageCostChargeTypeEnum];
/** 관리비 기타 부과 세부 타입 (실비 근거) */
export const ManageCostEtcChargeBasisEnum = {
  /** 세대별 계량기 */
  ByIndividualMeter: 'BY_INDIVIDUAL_METER',
  /** 관리규약에 따라 부과 */
  ByRegulations: 'BY_REGULATIONS',
  /** 면적/세대별 + 사용량 기준 */
  CommonByAreaOrUnitsAndUsageByMeter: 'COMMON_BY_AREA_OR_UNITS_AND_USAGE_BY_METER',
  /** 중개의뢰인 추정 제공 */
  EstimatedByAgentDueToNoOwnerInfo: 'ESTIMATED_BY_AGENT_DUE_TO_NO_OWNER_INFO',
  /** 기타 (직접입력) */
  Etc: 'ETC',
  /** 전체 사용량을 세대수로 나눔 */
  SharedByUnits: 'SHARED_BY_UNITS'
} as const;

export type ManageCostEtcChargeBasisEnum = typeof ManageCostEtcChargeBasisEnum[keyof typeof ManageCostEtcChargeBasisEnum];
/** 관리비 확인 불가 사유 */
export const ManageCostUnavailableReasonEnum = {
  /** 단독주택 */
  SingleHouse: 'SINGLE_HOUSE',
  /** 오피스텔 제외 상가 */
  StoreNotOfficetel: 'STORE_NOT_OFFICETEL',
  /** 미등기 / 신축 */
  UnregisteredOrNew: 'UNREGISTERED_OR_NEW'
} as const;

export type ManageCostUnavailableReasonEnum = typeof ManageCostUnavailableReasonEnum[keyof typeof ManageCostUnavailableReasonEnum];
/** 관리비 산출 기준 */
export const ManageCostCalculationPeriodEnum = {
  /** 최근 1년 평균 */
  Avg_1Year: 'AVG_1_YEAR',
  /** 최근 3개월 평균 */
  Avg_3Months: 'AVG_3_MONTHS',
  /** 기타 (직접입력) */
  Etc: 'ETC',
  /** 직전 월 */
  LastMonth: 'LAST_MONTH'
} as const;

export type ManageCostCalculationPeriodEnum = typeof ManageCostCalculationPeriodEnum[keyof typeof ManageCostCalculationPeriodEnum];
export type RealtyPost = Node & {
  __typename?: 'RealtyPost';
  id: Scalars['ID'];
  title: Scalars['String'];
  images: Array<Scalars['String']>;
  author?: Maybe<KarrotUser>;
  writerType: WriterTypeEnum;
  /** 집주인 인증 여부 */
  isWriterVerified?: Maybe<Scalars['Boolean']>;
  /** 법인 집주인 인증 여부 */
  isWriterVerifiedCorporate?: Maybe<Scalars['Boolean']>;
  /** 작성자 유형 표기값 */
  writerTypeText?: Maybe<Scalars['String']>;
  salesType: SalesTypeEnum;
  trades: Array<ArticleTrade>;
  coordinate: RealtyCoordinates;
  createdAt: Scalars['String'];
  chatRoomCount: Scalars['Int'];
  watchCount: Scalars['Int'];
  viewCount: Scalars['Int'];
  area?: Maybe<Scalars['String']>;
  areaPyeong?: Maybe<Scalars['String']>;
  supplyArea?: Maybe<Scalars['String']>;
  supplyAreaPyeong?: Maybe<Scalars['String']>;
  roomCnt?: Maybe<Scalars['Int']>;
  bathroomCnt?: Maybe<Scalars['Int']>;
  floor?: Maybe<Scalars['String']>;
  topFloor?: Maybe<Scalars['String']>;
  options: Array<ArticleOption>;
  moveInDate?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  region: Region;
  address: Scalars['String'];
  addressInfo: Scalars['String'];
  recommendedRealtyPosts: Array<RealtyPost>;
  status: RealtyArticleStatusEnum;
  appSchemaPath: Scalars['String'];
  /** @deprecated use bizProfile */
  broker?: Maybe<Broker>;
  /** @deprecated use bizProfile */
  brokerTelephoneNumber?: Maybe<Scalars['String']>;
  bizProfile?: Maybe<RealtyBrokerBusinessProfile>;
  buildingApprovalDate?: Maybe<Scalars['String']>;
  includeManageCostOptionV2: Array<IncludeManageCostOptionV2>;
  includeManageCostOptionV3: Array<IncludeManageCostOptionV3>;
  buildingName?: Maybe<Scalars['String']>;
  manageCost?: Maybe<Scalars['Float']>;
  etcManageCost?: Maybe<Scalars['Float']>;
  /**
   * 기존 manageCost는 중개사 매물에서는 공용 관리비를 의미하고
   * 직거래 매물에서는 총 관리비를 의미했으나 명확하지 않아
   * 총 관리비 항목을 추가했어요.
   */
  totalManageCost?: Maybe<Scalars['Float']>;
  /** 관리비 미포함 항목(default 빈배열) */
  excludeManageCostOption?: Maybe<Array<ArticleManageCostOptionEnum>>;
  /** 관리비 부과 타입: fixed=정액, etc=기타, unavailable=확인 불가 */
  manageCostChargeType?: Maybe<ManageCostChargeTypeEnum>;
  /** 관리비 세부내역 고지 여부 */
  manageCostDetailIsDisclosed?: Maybe<Scalars['Boolean']>;
  /** 관리비 기타 부과 세부 타입 (실비 근거) */
  manageCostEtcChargeBasis?: Maybe<ManageCostEtcChargeBasisEnum>;
  /**
   * 직접 입력한 관리비 기타 부과 세부 타입 (실비 근거)
   * manageCostEtcChargeBasis가 ETC일 때 사용자가 직접 입력한 값
   */
  manageCostEtcChargeBasisCustom?: Maybe<Scalars['String']>;
  /** 관리비 확인 불가 사유 */
  manageCostUnavailableReason?: Maybe<ManageCostUnavailableReasonEnum>;
  /** 관리비 산출 기준 */
  manageCostCalculationPeriod?: Maybe<ManageCostCalculationPeriodEnum>;
  /**
   * 직접 입력한 관리비 산출 기준
   * manageCostCalculationPeriod가 ETC일 때 사용자가 직접 입력한 값
   */
  manageCostCalculationPeriodCustom?: Maybe<Scalars['String']>;
  isUnknownManageCost?: Maybe<Scalars['Boolean']>;
  buildingUsage?: Maybe<BuildingUsageEnum>;
  buildingOrientation?: Maybe<ArticleBuildingOrientationEnum>;
  availableParkingSpots?: Maybe<Scalars['Float']>;
  availableParkingSpotsV2?: Maybe<Scalars['Float']>;
  availableTotalParkingSpots?: Maybe<Scalars['Float']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};


export type RealtyPostRecommendedRealtyPostsArgs = {
  limit: Scalars['Int'];
};

export type RealtyPostsAllPage = Node & {
  __typename?: 'RealtyPostsAllPage';
  id: Scalars['ID'];
  realtyPosts: Array<RealtyPost>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type LocalProfileCategory = Node & {
  __typename?: 'LocalProfileCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  levels: Array<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type Image = Node & {
  __typename?: 'Image';
  id: Scalars['ID'];
  url: Scalars['String'];
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CcLocalProfile = Node & {
  __typename?: 'CCLocalProfile';
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
  starRating: Scalars['Float'];
  reviewCount: Scalars['Int'];
  category?: Maybe<LocalProfileCategory>;
  region?: Maybe<Region>;
  profilePicture?: Maybe<Image>;
  isReservable: Scalars['Boolean'];
  hasUsableCoupon: Scalars['Boolean'];
  isStoreOnSale: Scalars['Boolean'];
  followersCount: Scalars['Int'];
  permalink: Scalars['String'];
  jibunAddress?: Maybe<Scalars['String']>;
  roadAddress?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type LocalProfileAllPage = Node & {
  __typename?: 'LocalProfileAllPage';
  id: Scalars['ID'];
  localProfiles: Array<CcLocalProfile>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CommunityGroupBoardCategory = {
  __typename?: 'CommunityGroupBoardCategory';
  categoryName: Scalars['String'];
  posts: Array<Maybe<CommunityGroupPost>>;
};

export type CommunityGroupPost = {
  __typename?: 'CommunityGroupPost';
  id: Scalars['ID'];
  content: Scalars['String'];
  categoryName: Scalars['String'];
  authorName: Scalars['String'];
  firstImage?: Maybe<Scalars['String']>;
  emotionCount: Scalars['Int'];
  commentCount: Scalars['Int'];
  groupOnly: Scalars['Boolean'];
  createdAt: Scalars['String'];
};

export type CommunityGroupMember = {
  __typename?: 'CommunityGroupMember';
  profileImage: Scalars['String'];
  nickname: Scalars['String'];
  description: Scalars['String'];
  region: Region;
  role: GroupMemberRole;
};

export const GroupMemberRole = {
  None: 'NONE',
  Member: 'MEMBER',
  Manager: 'MANAGER',
  SuperHost: 'SUPER_HOST'
} as const;

export type GroupMemberRole = typeof GroupMemberRole[keyof typeof GroupMemberRole];
export type PlaceTag = {
  __typename?: 'PlaceTag';
  name: Scalars['String'];
  coordinate: PlaceTagCoordinates;
  addressText?: Maybe<Scalars['String']>;
  region?: Maybe<Region>;
};

export type PlaceTagCoordinates = {
  __typename?: 'PlaceTagCoordinates';
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type CommunityGroupMeetup = {
  __typename?: 'CommunityGroupMeetup';
  id: Scalars['ID'];
  name: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  groupOnly: Scalars['Boolean'];
  progressStatus: CommunityGroupMeetupProgressStatus;
  currentParticipantsNumber: Scalars['Int'];
  maximumParticipantsNumber: Scalars['Int'];
  meetAt: Scalars['String'];
  placeTag?: Maybe<PlaceTag>;
};

export const CommunityGroupMeetupProgressStatus = {
  Opened: 'OPENED',
  Closed: 'CLOSED',
  FullyRecruited: 'FULLY_RECRUITED'
} as const;

export type CommunityGroupMeetupProgressStatus = typeof CommunityGroupMeetupProgressStatus[keyof typeof CommunityGroupMeetupProgressStatus];
export type CommunityGroup = Node & {
  __typename?: 'CommunityGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  backgroundImage: Scalars['String'];
  profileImage: Scalars['String'];
  description: Scalars['String'];
  memberCount: Scalars['Int'];
  postCount: Scalars['Int'];
  meetupCount: Scalars['Int'];
  /** 마지막 활동 시각 */
  lastActivatedAt: Scalars['String'];
  /** 자주 모이는 장소 */
  favoriteLocationPlaceTag?: Maybe<PlaceTag>;
  region: Region;
  categoryName: Scalars['String'];
  ageRange?: Maybe<Scalars['String']>;
  members: Array<CommunityGroupMember>;
  photoImages: Array<Scalars['String']>;
  boardCategories: Array<CommunityGroupBoardCategory>;
  meetups: Array<CommunityGroupMeetup>;
  appScheme: Scalars['String'];
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CommunityGroupAllPage = Node & {
  __typename?: 'CommunityGroupAllPage';
  id: Scalars['ID'];
  communityGroups: Array<CommunityGroup>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CommunityAgoraContentsWriter = {
  __typename?: 'CommunityAgoraContentsWriter';
  nickName: Scalars['String'];
  userStatus: CommunityContentsWriterStatus;
  profileImageUrl?: Maybe<Scalars['String']>;
  userTemperature?: Maybe<Scalars['Float']>;
  writeRegionName?: Maybe<Scalars['String']>;
  writeRegionCheckInCount?: Maybe<Scalars['Int']>;
  moveToAppTargetUrl?: Maybe<Scalars['String']>;
};

export type CommunityAgoraEmotionDetail = {
  __typename?: 'CommunityAgoraEmotionDetail';
  kind: Scalars['String'];
  count: Scalars['Int'];
};

export type CommunityAgoraPlaceTag = {
  __typename?: 'CommunityAgoraPlaceTag';
  placeTagId?: Maybe<Scalars['Int']>;
  placeTagType?: Maybe<Scalars['String']>;
  placeTagTitle?: Maybe<Scalars['String']>;
  placeTagCategory?: Maybe<Scalars['String']>;
  placeTaggerId?: Maybe<Scalars['Int']>;
  placeTaggerNickname?: Maybe<Scalars['String']>;
  placeTagLatitude?: Maybe<Scalars['Float']>;
  placeTagLongitude?: Maybe<Scalars['Float']>;
  totalReviewCount?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  jibunAddress?: Maybe<Scalars['String']>;
  isAutoTag?: Maybe<Scalars['Boolean']>;
};

export type CommunityArticlePoll = {
  __typename?: 'CommunityArticlePoll';
  moveToAppTargetUrl: Scalars['String'];
  options?: Maybe<Array<CommunityArticlePollOption>>;
  enableMultipleChoice: Scalars['String'];
  totalVoteCount: Scalars['Int'];
  totalVoterCount: Scalars['Int'];
};

export type CommunityArticlePollOption = {
  __typename?: 'CommunityArticlePollOption';
  title: Scalars['String'];
  voteCount: Scalars['Int'];
};

export type CommunityArticleComments = {
  __typename?: 'CommunityArticleComments';
  visibleMoreCommentView: Scalars['Boolean'];
  moreCommentsMoveToAppTargetUrl: Scalars['String'];
  writeCommentsMoveToAppTargetUrl: Scalars['String'];
  commentEmotionMoveToAppTargetUrl: Scalars['String'];
  subCommentsMoveToAppTargetUrl: Scalars['String'];
  createdSortedComments: Array<CommunityArticleComment>;
  recentSortedComments: Array<CommunityArticleComment>;
};

export type CommunityArticleComment = {
  __typename?: 'CommunityArticleComment';
  id: Scalars['String'];
  articleId: Scalars['String'];
  parentCommentId?: Maybe<Scalars['String']>;
  status: CommunityArticleAndCommentStatus;
  writer: CommunityAgoraContentsWriter;
  content: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  placeTag?: Maybe<CommunityAgoraPlaceTag>;
  emotionCounts?: Maybe<Array<CommunityAgoraEmotionDetail>>;
  subComments?: Maybe<Array<CommunityArticleComment>>;
};

export type CommunityRecommendedArticle = {
  __typename?: 'CommunityRecommendedArticle';
  id: Scalars['String'];
  title: Scalars['String'];
  content: Scalars['String'];
  subject: Scalars['String'];
  regionId?: Maybe<Scalars['Int']>;
  regionName?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  commentsCount?: Maybe<Scalars['Int']>;
  emotionsCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  permalink: Scalars['String'];
};

export const CommunityArticleAndCommentStatus = {
  Normal: 'NORMAL',
  Deleted: 'DELETED',
  Blocked: 'BLOCKED'
} as const;

export type CommunityArticleAndCommentStatus = typeof CommunityArticleAndCommentStatus[keyof typeof CommunityArticleAndCommentStatus];
export const CommunityContentsWriterStatus = {
  Normal: 'NORMAL',
  Deleted: 'DELETED',
  Unknown: 'UNKNOWN',
  BlockedByMe: 'BLOCKED_BY_ME'
} as const;

export type CommunityContentsWriterStatus = typeof CommunityContentsWriterStatus[keyof typeof CommunityContentsWriterStatus];
export type CommunityArticle = Node & {
  __typename?: 'CommunityArticle';
  id: Scalars['ID'];
  writer: CommunityAgoraContentsWriter;
  regionId?: Maybe<Scalars['Int']>;
  regionName: Scalars['String'];
  subjectId: Scalars['String'];
  subject: Scalars['String'];
  title: Scalars['String'];
  content: Scalars['String'];
  status: CommunityArticleAndCommentStatus;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  commentsCount: Scalars['Int'];
  emotionCount: Scalars['Int'];
  readsCount: Scalars['Int'];
  watchesCount: Scalars['Int'];
  emotionSummaryMoveToAppTargetUrl: Scalars['String'];
  emotionMoveToAppTargetUrl: Scalars['String'];
  commentMoveToAppTargetUrl: Scalars['String'];
  watchedMoveToAppTargetUrl: Scalars['String'];
  emotionDetails?: Maybe<Array<CommunityAgoraEmotionDetail>>;
  placeTag?: Maybe<CommunityAgoraPlaceTag>;
  poll?: Maybe<CommunityArticlePoll>;
  autoHashtags?: Maybe<Array<Scalars['String']>>;
  comments: CommunityArticleComments;
  recommendedArticles?: Maybe<Array<CommunityRecommendedArticle>>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CommunityArticleAllPage = Node & {
  __typename?: 'CommunityArticleAllPage';
  id: Scalars['ID'];
  communityArticles: Array<CommunityArticle>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type MetaData = {
  __typename?: 'MetaData';
  imageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type PickupQr = Node & {
  __typename?: 'PickupQR';
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['String']>;
  meta?: Maybe<MetaData>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type ExpertQr = Node & {
  __typename?: 'ExpertQR';
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
  businessAccountId?: Maybe<Scalars['Int']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  ping: Scalars['Boolean'];
  node?: Maybe<Node>;
  region?: Maybe<Region>;
  recentRegions: Array<Region>;
  fleamarketCategory?: Maybe<FleamarketCategory>;
  recentFleamarketCategories: Array<FleamarketCategory>;
  karrotUser?: Maybe<KarrotUser>;
  recentKarrotUsers: Array<KarrotUser>;
  fleamarketArticle?: Maybe<FleamarketArticle>;
  recentFleamarketArticles: Array<FleamarketArticle>;
  homePage: HomePage;
  allPage: AllPage;
  categoriesPage: CategoriesPage;
  businessPost?: Maybe<BusinessPost>;
  recentBusinessPosts: Array<BusinessPost>;
  localProfile?: Maybe<LocalProfile>;
  recentLocalProfiles: Array<LocalProfile>;
  carPost?: Maybe<CarPost>;
  recentCarPosts: Array<CarPost>;
  carAllPage: CarAllPage;
  jobPost?: Maybe<JobPost>;
  recentJobPosts: Array<JobPost>;
  jobsAllPage: JobsAllPage;
  realtyPost?: Maybe<RealtyPost>;
  recentRealtyPosts: Array<RealtyPost>;
  realtyPostsAllPage: RealtyPostsAllPage;
  localProfileCategory?: Maybe<LocalProfileCategory>;
  recentLocalProfileCategories: Array<LocalProfileCategory>;
  image?: Maybe<Image>;
  recentImages: Array<Image>;
  ccLocalProfile?: Maybe<CcLocalProfile>;
  recentCCLocalProfiles: Array<CcLocalProfile>;
  localProfileAllPage: LocalProfileAllPage;
  communityGroup?: Maybe<CommunityGroup>;
  recentCommunityGroups: Array<CommunityGroup>;
  communityGroupAllPage: CommunityGroupAllPage;
  communityArticle?: Maybe<CommunityArticle>;
  recentCommunityArticles: Array<CommunityArticle>;
  communityArticleAllPage: CommunityArticleAllPage;
  pickupQr?: Maybe<PickupQr>;
  recentPickupQRS: Array<PickupQr>;
  expertQr?: Maybe<ExpertQr>;
  recentExpertQRS: Array<ExpertQr>;
};


export type QueryNodeArgs = {
  nodeId: Scalars['String'];
};


export type QueryRegionArgs = {
  id: Scalars['String'];
};


export type QueryRecentRegionsArgs = {
  size: Scalars['Int'];
};


export type QueryFleamarketCategoryArgs = {
  id: Scalars['String'];
};


export type QueryRecentFleamarketCategoriesArgs = {
  size: Scalars['Int'];
};


export type QueryKarrotUserArgs = {
  id: Scalars['String'];
};


export type QueryRecentKarrotUsersArgs = {
  size: Scalars['Int'];
};


export type QueryFleamarketArticleArgs = {
  id: Scalars['String'];
};


export type QueryRecentFleamarketArticlesArgs = {
  size: Scalars['Int'];
};


export type QueryHomePageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryAllPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryCategoriesPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryBusinessPostArgs = {
  id: Scalars['String'];
};


export type QueryRecentBusinessPostsArgs = {
  size: Scalars['Int'];
};


export type QueryLocalProfileArgs = {
  id: Scalars['String'];
};


export type QueryRecentLocalProfilesArgs = {
  size: Scalars['Int'];
};


export type QueryCarPostArgs = {
  id: Scalars['String'];
};


export type QueryRecentCarPostsArgs = {
  size: Scalars['Int'];
};


export type QueryCarAllPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryJobPostArgs = {
  id: Scalars['String'];
};


export type QueryRecentJobPostsArgs = {
  size: Scalars['Int'];
};


export type QueryJobsAllPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryRealtyPostArgs = {
  id: Scalars['String'];
};


export type QueryRecentRealtyPostsArgs = {
  size: Scalars['Int'];
};


export type QueryRealtyPostsAllPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryLocalProfileCategoryArgs = {
  id: Scalars['String'];
};


export type QueryRecentLocalProfileCategoriesArgs = {
  size: Scalars['Int'];
};


export type QueryImageArgs = {
  id: Scalars['String'];
};


export type QueryRecentImagesArgs = {
  size: Scalars['Int'];
};


export type QueryCcLocalProfileArgs = {
  id: Scalars['String'];
};


export type QueryRecentCcLocalProfilesArgs = {
  size: Scalars['Int'];
};


export type QueryLocalProfileAllPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryCommunityGroupArgs = {
  id: Scalars['String'];
};


export type QueryRecentCommunityGroupsArgs = {
  size: Scalars['Int'];
};


export type QueryCommunityGroupAllPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryCommunityArticleArgs = {
  id: Scalars['String'];
};


export type QueryRecentCommunityArticlesArgs = {
  size: Scalars['Int'];
};


export type QueryCommunityArticleAllPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryPickupQrArgs = {
  id: Scalars['String'];
};


export type QueryRecentPickupQrsArgs = {
  size: Scalars['Int'];
};


export type QueryExpertQrArgs = {
  id: Scalars['String'];
};


export type QueryRecentExpertQrsArgs = {
  size: Scalars['Int'];
};

export type T1f4rroyh8g2no4lc5sqts7cQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['String']>;
}>;


export type T1f4rroyh8g2no4lc5sqts7cQuery = { __typename?: 'Query', homePage: { __typename?: 'HomePage', id: string, regionId?: string | null, regionName?: string | null, sections: Array<{ __typename?: 'HomePageSection', header: string, position: number, type: string, filter?: { __typename?: 'HomePageSectionFilter', regionId?: string | null, categoryId?: string | null, price?: string | null, sortBy?: string | null, search?: string | null } | null, articles?: Array<{ __typename?: 'FleamarketArticle', id: string, href: string, title: string, price?: string | null, thumbnail?: string | null, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, category?: { __typename?: 'FleamarketCategory', thumbnail: string } | null, region: { __typename?: 'Region', name: string } }> | null, categories?: Array<{ __typename?: 'FleamarketCategory', id: string, dbId: string, href: string, name: string, webIcon?: string | null }> | null }> } };

export type Mi8bgungqt1x8yv90we35urfQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  only_on_sale?: InputMaybe<Scalars['Boolean']>;
}>;


export type Mi8bgungqt1x8yv90we35urfQuery = { __typename?: 'Query', allPage: { __typename?: 'AllPage', id: string, href: string, fleamarketArticles: Array<{ __typename?: 'FleamarketArticle', id: string, href: string, price?: string | null, title: string, thumbnail?: string | null, status: FleamarketArticleStatus, content: string, createdAt: string, boostedAt: string, user?: { __typename?: 'KarrotUser', dbId: string, nickname: string } | null, regionId: { __typename?: 'Region', id: string, dbId: string, name: string }, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, category?: { __typename?: 'FleamarketCategory', thumbnail: string } | null }> } };

export type Matd7o4pbwa78imhrveh8a8oQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type Matd7o4pbwa78imhrveh8a8oQuery = { __typename?: 'Query', region?: { __typename?: 'Region', id: string, href: string, dbId: string, nodeId: string, name: string, countryCode?: string | null } | null };

export type UserArticle_UserPageFragment = { __typename?: 'FleamarketArticle', id: string, title: string, thumbnail?: string | null, status: FleamarketArticleStatus, price?: string | null, favoriteCount: number, chatCount: number, category?: { __typename?: 'FleamarketCategory', thumbnail: string } | null, regionId: { __typename?: 'Region', name: string }, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null };

export type Rsu5tqudsype0qpq7d75w2qpQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Rsu5tqudsype0qpq7d75w2qpQuery = { __typename?: 'Query', karrotUser?: { __typename?: 'KarrotUser', id: string, dbId: string, nickname: string, href: string, score: number, scoreSymbol: string, profileImage: string, reviewCount: number, locationName?: { __typename?: 'KarrotUserH3LocationName', name?: string | null } | null, region: { __typename?: 'Region', name: string, dbId: string }, userArticles: Array<{ __typename?: 'FleamarketArticle', id: string, title: string, thumbnail?: string | null, status: FleamarketArticleStatus, price?: string | null, favoriteCount: number, chatCount: number, category?: { __typename?: 'FleamarketCategory', thumbnail: string } | null, regionId: { __typename?: 'Region', name: string }, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null }>, receivedReviews: Array<{ __typename?: 'KarrotUserReview', userImage?: string | null, nickname?: string | null, regionName?: string | null, content?: string | null, createdAt?: string | null, articleThumbnail?: string | null, isSeller?: boolean | null, userId?: { __typename?: 'KarrotUser', id: string } | null, locationName?: { __typename?: 'KarrotUserH3LocationName', name?: string | null } | null }> } | null };

export type Vq3t1l3qhxp9vm4z028a5f5wQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Vq3t1l3qhxp9vm4z028a5f5wQuery = { __typename?: 'Query', fleamarketArticle?: { __typename?: 'FleamarketArticle', id: string, dbId: string, nodeId: string, href: string, title: string, images: Array<string>, createdAt: string, boostedAt: string, price?: string | null, status: FleamarketArticleStatus, content: string, favoriteCount: number, chatCount: number, viewCount: number, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, region: { __typename?: 'Region', name: string, dbId: string, nodeId: string, countryCode?: string | null }, user?: { __typename?: 'KarrotUser', id: string, dbId: string, href: string, nickname: string, profileImage: string, score: number, scoreSymbol: string, reviewCount: number, locationName?: { __typename?: 'KarrotUserH3LocationName', name?: string | null } | null, region: { __typename?: 'Region', dbId: string, name: string }, userArticles: Array<{ __typename?: 'FleamarketArticle', id: string, title: string, price?: string | null, thumbnail?: string | null, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, region: { __typename?: 'Region', name: string }, category?: { __typename?: 'FleamarketCategory', thumbnail: string } | null }> } | null, category?: { __typename?: 'FleamarketCategory', id: string, dbId: string, href: string, name: string, thumbnail: string } | null, recommendedArticles: Array<{ __typename?: 'FleamarketArticle', id: string, href: string, title: string, price?: string | null, thumbnail?: string | null, status: FleamarketArticleStatus, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, region: { __typename?: 'Region', name: string }, category?: { __typename?: 'FleamarketCategory', name: string, thumbnail: string } | null }>, articlePropertyContents: Array<{ __typename?: 'FleamarketArticleProperty', title: string, content: string, displayOrder: number, isActive: boolean }>, comments?: Array<{ __typename?: 'FleamarketArticleComment', id: number, parentId?: number | null, content?: string | null, displayLocationName?: string | null, createdAt?: string | null, userNickname?: string | null, userProfileImage?: string | null, userId?: { __typename?: 'KarrotUser', id: string } | null, children?: Array<{ __typename?: 'FleamarketArticleComment', id: number, parentId?: number | null, content?: string | null, displayLocationName?: string | null, createdAt?: string | null, userNickname?: string | null, userProfileImage?: string | null, userId?: { __typename?: 'KarrotUser', id: string } | null } | null> | null } | null> | null } | null };

export type Ke67vlmxclra2bg8nfxz426qQueryVariables = Exact<{ [key: string]: never; }>;


export type Ke67vlmxclra2bg8nfxz426qQuery = { __typename?: 'Query', categoriesPage: { __typename?: 'CategoriesPage', fleamarketCategory: Array<{ __typename?: 'FleamarketCategory', id: string, dbId: string, name: string, href: string, webIcon?: string | null }> } };

export type TitleSection_LocalProfileFragment = { __typename?: 'LocalProfile', name: string, count: { __typename?: 'Count', reviewCount: number, reviewStarRating: number, followerCount: number }, region?: { __typename?: 'Region', name1?: string | null, name2?: string | null, name3?: string | null, depth: number, dbId: string } | null, category?: { __typename?: 'BusinessCategory', name: string } | null };

export type BusinessDay_BusinessProfileBusinessDayBreakHoursFragment = { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null };

export type BusinessDays_BusinessProfileWeeklyBusinessDaysFragment = { __typename?: 'BusinessProfileWeeklyBusinessDays', monday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, tuesday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, wednesday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, thursday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, friday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, saturday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, sunday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null } };

export type BusinessDay_BusinessProfileUpcomingBusinessDayFragment = { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } };

export type BusinessDays_BusinessProfileWeeklyUpcomingBusinessDaysFragment = { __typename?: 'BusinessProfileWeeklyUpcomingBusinessDays', monday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, tuesday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, wednesday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, thursday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, friday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, saturday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, sunday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } } };

export type TimeInformation_BusinessProfileOperationTimeFragment = { __typename?: 'BusinessProfileOperationTime', extra?: string | null, businessDays?: { __typename?: 'BusinessProfileWeeklyBusinessDays', monday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, tuesday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, wednesday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, thursday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, friday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, saturday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, sunday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null } } | null, upcomingWeeklyBusinessTime?: { __typename?: 'UpcomingWeeklyBusinessTime', businessTimeMap: { __typename?: 'BusinessProfileWeeklyUpcomingBusinessDays', monday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, tuesday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, wednesday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, thursday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, friday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, saturday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, sunday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } } } } | null };

export type BodySection_LocalProfileFragment = { __typename?: 'LocalProfile', supportReservationV2: boolean, additionalInformation?: Array<string> | null, phone?: string | null, safeNumber?: string | null, url?: string | null, availableServiceFieldNames: Array<string>, coordinates?: { __typename?: 'BusinessProfileCoordinates', lat: number, lng: number } | null, operationTime?: { __typename?: 'BusinessProfileOperationTime', extra?: string | null, businessDays?: { __typename?: 'BusinessProfileWeeklyBusinessDays', monday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, tuesday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, wednesday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, thursday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, friday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, saturday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, sunday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null } } | null, upcomingWeeklyBusinessTime?: { __typename?: 'UpcomingWeeklyBusinessTime', businessTimeMap: { __typename?: 'BusinessProfileWeeklyUpcomingBusinessDays', monday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, tuesday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, wednesday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, thursday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, friday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, saturday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, sunday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } } } } | null } | null, address?: { __typename?: 'LocalProfileAddress', road?: string | null, jibun?: string | null, extra?: string | null } | null };

export type CouponSection_LocalProfileFragment = { __typename?: 'LocalProfile', targetUri: string, coupons: Array<{ __typename?: 'Coupon', name: string, updatedAt: string, expiresAt?: string | null }> };

export type ProductSection_LocalProfileFragment = { __typename?: 'LocalProfile', targetUri: string, products: Array<{ __typename?: 'BusinessProduct', id?: number | null, name?: string | null, canBeDelivered?: boolean | null, isFreeDelivery?: boolean | null, isSameDayDelivery?: boolean | null, thumbnails: Array<{ __typename?: 'Thumbnail', thumbnail?: string | null }>, salePrice?: { __typename?: 'BusinessProductPrice', currency: MoneyCurrency, amount: number } | null, price: { __typename?: 'BusinessProductPrice', currency: MoneyCurrency, amount: number } }> };

export type IntroductionSection_LocalProfileFragment = { __typename?: 'LocalProfile', description: string, lastAccess?: { __typename?: 'LastAccess', lastAccessedAt?: string | null, summary?: string | null } | null, businessVerification?: { __typename?: 'BusinessVefification', verified: boolean, licenses: Array<{ __typename?: 'License', label?: string | null, meta?: Array<{ __typename?: 'Meta', type?: MetaType | null, value?: string | null, caption?: string | null }> | null }> } | null };

export type PricingSection_LocalProfileFragment = { __typename?: 'LocalProfile', pricing?: { __typename?: 'Pricing', pricings: Array<{ __typename?: 'BusinessPricing', name: string, description?: string | null, isRepresentative: boolean, orderNumber?: number | null, price?: number | null, maxPrice?: number | null, priceKind: BusinessPricingPriceKind }>, pictures: Array<{ __typename?: 'BusinessPricingPicture', thumbnail?: string | null }> } | null };

export type BusinessPostSection_LocalProfileFragment = { __typename?: 'LocalProfile', bizPosts: Array<{ __typename?: 'BusinessPost', id: string, title: string, updatedAt: string, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }>, counter: { __typename?: 'Counter', bookmarkCount: number, commentCount: number }, images: Array<{ __typename?: 'BusinessPostMediaObject', thumbnailUrl?: string | null }> }> };

export type BizReviewProfileFragment = { __typename?: 'BusinessReview', createdAt: string, user: { __typename?: 'BusinessReviewProfile', nickname?: string | null, regionCheckinsCount?: number | null, profileImage?: string | null }, reviewerInfo: { __typename?: 'ReviewerInfo', followBusinessAccount: boolean }, actorRegion: { __typename?: 'BusinessReviewActorRegion', name?: string | null } };

export type ReviewSection_LocalProfileFragment = { __typename?: 'LocalProfile', reviews: Array<{ __typename?: 'BusinessReview', starRating: number, content: string, likesCount: number, postStopped: boolean, createdAt: string, extend: { __typename?: 'ReviewExtend', productName?: string | null, reviewCount?: number | null }, images: Array<{ __typename?: 'LocalProfileImage', thumbnailUrl: string }>, tags: Array<{ __typename?: 'Tag', content: string }>, comment?: { __typename?: 'ReviewComment', content: string, createdAt: string } | null, user: { __typename?: 'BusinessReviewProfile', nickname?: string | null, regionCheckinsCount?: number | null, profileImage?: string | null }, reviewerInfo: { __typename?: 'ReviewerInfo', followBusinessAccount: boolean }, actorRegion: { __typename?: 'BusinessReviewActorRegion', name?: string | null } }> };

export type Kivgs9on2s6vovm73dtpyi7vQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Kivgs9on2s6vovm73dtpyi7vQuery = { __typename?: 'Query', localProfile?: { __typename?: 'LocalProfile', id: string, dbId: string, href: string, nodeId: string, name: string, targetUri: string, description: string, thumbImageUrl?: string | null, backgroundPictures: Array<string>, status: BusinessProfileStatus, promotion?: string | null, notice?: string | null, editedAt: string, supportReservationV2: boolean, additionalInformation?: Array<string> | null, phone?: string | null, safeNumber?: string | null, url?: string | null, availableServiceFieldNames: Array<string>, ownerBa?: { __typename?: 'BusinessAccount', baId?: number | null } | null, region?: { __typename?: 'Region', name3?: string | null, name1?: string | null, name2?: string | null, depth: number, dbId: string } | null, count: { __typename?: 'Count', reviewCount: number, reviewStarRating: number, followerCount: number }, category?: { __typename?: 'BusinessCategory', name: string } | null, coordinates?: { __typename?: 'BusinessProfileCoordinates', lat: number, lng: number } | null, operationTime?: { __typename?: 'BusinessProfileOperationTime', extra?: string | null, businessDays?: { __typename?: 'BusinessProfileWeeklyBusinessDays', monday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, tuesday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, wednesday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, thursday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, friday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, saturday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null }, sunday: { __typename?: 'BusinessProfileBusinessDay', closed: boolean, open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null } } | null, upcomingWeeklyBusinessTime?: { __typename?: 'UpcomingWeeklyBusinessTime', businessTimeMap: { __typename?: 'BusinessProfileWeeklyUpcomingBusinessDays', monday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, tuesday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, wednesday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, thursday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, friday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, saturday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } }, sunday: { __typename?: 'BusinessProfileUpcomingBusinessDay', open24Hours: boolean, hours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, breakHours?: { __typename?: 'BusinessProfileBusinessDayBreakHours', to: string, from: string } | null, dailyOperationInfo: { __typename?: 'BusinessProfileDailyOperationInfo', status: BusinessProfileDailyOperationInfoStatus, closingHoliday?: { __typename?: 'BusinessProfileHolidayInfo', greatHoliday?: boolean | null, name?: string | null } | null } } } } | null } | null, address?: { __typename?: 'LocalProfileAddress', road?: string | null, jibun?: string | null, extra?: string | null } | null, coupons: Array<{ __typename?: 'Coupon', name: string, updatedAt: string, expiresAt?: string | null }>, products: Array<{ __typename?: 'BusinessProduct', id?: number | null, name?: string | null, canBeDelivered?: boolean | null, isFreeDelivery?: boolean | null, isSameDayDelivery?: boolean | null, thumbnails: Array<{ __typename?: 'Thumbnail', thumbnail?: string | null }>, salePrice?: { __typename?: 'BusinessProductPrice', currency: MoneyCurrency, amount: number } | null, price: { __typename?: 'BusinessProductPrice', currency: MoneyCurrency, amount: number } }>, lastAccess?: { __typename?: 'LastAccess', lastAccessedAt?: string | null, summary?: string | null } | null, businessVerification?: { __typename?: 'BusinessVefification', verified: boolean, licenses: Array<{ __typename?: 'License', label?: string | null, meta?: Array<{ __typename?: 'Meta', type?: MetaType | null, value?: string | null, caption?: string | null }> | null }> } | null, pricing?: { __typename?: 'Pricing', pricings: Array<{ __typename?: 'BusinessPricing', name: string, description?: string | null, isRepresentative: boolean, orderNumber?: number | null, price?: number | null, maxPrice?: number | null, priceKind: BusinessPricingPriceKind }>, pictures: Array<{ __typename?: 'BusinessPricingPicture', thumbnail?: string | null }> } | null, bizPosts: Array<{ __typename?: 'BusinessPost', id: string, title: string, updatedAt: string, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }>, counter: { __typename?: 'Counter', bookmarkCount: number, commentCount: number }, images: Array<{ __typename?: 'BusinessPostMediaObject', thumbnailUrl?: string | null }> }>, reviews: Array<{ __typename?: 'BusinessReview', starRating: number, content: string, likesCount: number, postStopped: boolean, createdAt: string, extend: { __typename?: 'ReviewExtend', productName?: string | null, reviewCount?: number | null }, images: Array<{ __typename?: 'LocalProfileImage', thumbnailUrl: string }>, tags: Array<{ __typename?: 'Tag', content: string }>, comment?: { __typename?: 'ReviewComment', content: string, createdAt: string } | null, user: { __typename?: 'BusinessReviewProfile', nickname?: string | null, regionCheckinsCount?: number | null, profileImage?: string | null }, reviewerInfo: { __typename?: 'ReviewerInfo', followBusinessAccount: boolean }, actorRegion: { __typename?: 'BusinessReviewActorRegion', name?: string | null } }> } | null };

export type BizProfileSummaryFragment = { __typename?: 'BusinessPost', targetUri: string, localProfileId?: { __typename?: 'LocalProfile', id: string, dbId: string, name: string, thumbImageUrl?: string | null, regionId?: { __typename?: 'Region', name: string } | null, count: { __typename?: 'Count', followerCount: number }, category?: { __typename?: 'BusinessCategory', name: string } | null } | null, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, userType: ActorType, businessAccountId?: string | null, userId?: { __typename?: 'KarrotUser', id: string, dbId: string, nickname: string, profileImage: string, score: number, regionId: { __typename?: 'Region', name: string, dbId: string } } | null }, category?: { __typename?: 'BusinessPostCategory', name: string } | null, counter: { __typename?: 'Counter', followCount: number }, region?: { __typename?: 'Region', name3?: string | null } | null };

export type PersonaFragment = { __typename?: 'PostActor', profileImageUrl: string, nickname: string, coordinates?: { __typename?: 'PostActorCoordinates', lat: number, lng: number } | null, region?: { __typename?: 'Region', name: string, name1?: string | null, name2?: string | null, name3?: string | null } | null };

export type CommentFragment = { __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> };

export type Comment_BusinessPostCommentFragment = { __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, subComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }>, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> };

export type CommentSection_BusinessPostFragment = { __typename?: 'BusinessPost', latestComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, subComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }>, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }>, oldestComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, subComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }>, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }> };

export type G9gp1qipve6s9bw790vcs9x5QueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type G9gp1qipve6s9bw790vcs9x5Query = { __typename?: 'Query', businessPost?: { __typename?: 'BusinessPost', id: string, promotion?: string | null, title: string, createdAt: string, targetUri: string, images: Array<{ __typename?: 'BusinessPostMediaObject', url?: string | null, thumbnailUrl?: string | null }>, category?: { __typename?: 'BusinessPostCategory', name: string } | null, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }>, counter: { __typename?: 'Counter', viewCount: number, chatRoomCount: number, bookmarkCount: number, commentCount: number, followCount: number }, region?: { __typename?: 'Region', name: string, name1?: string | null, name2?: string | null, name3?: string | null } | null, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, userType: ActorType, businessAccountId?: string | null, userId?: { __typename?: 'KarrotUser', id: string, dbId: string, nickname: string, profileImage: string, score: number, regionId: { __typename?: 'Region', name: string, dbId: string } } | null, coordinates?: { __typename?: 'PostActorCoordinates', lat: number, lng: number } | null, region?: { __typename?: 'Region', name: string, name1?: string | null, name2?: string | null, name3?: string | null } | null }, localProfileId?: { __typename?: 'LocalProfile', id: string, dbId: string, name: string, thumbImageUrl?: string | null, regionId?: { __typename?: 'Region', name: string } | null, count: { __typename?: 'Count', followerCount: number }, category?: { __typename?: 'BusinessCategory', name: string } | null } | null, latestComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, subComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }>, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }>, oldestComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, subComments: Array<{ __typename?: 'BusinessPostComment', createdAt: string, deleted: boolean, blocked: boolean, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }>, actor: { __typename?: 'PostActor', profileImageUrl: string, nickname: string, region?: { __typename?: 'Region', name3?: string | null } | null }, content: Array<{ __typename?: 'Content', type: ContentType, value?: string | null }> }> } | null };

export type Gfo93obxz2wx9y6kg84ilbh2QueryVariables = Exact<{
  regionId: Scalars['String'];
  carTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  fuelTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  saleTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  gears?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  modelYear?: InputMaybe<Scalars['String']>;
  driveDistance?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  regionRange?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<Scalars['String']>;
  series?: InputMaybe<Scalars['String']>;
  onlyOnSale?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type Gfo93obxz2wx9y6kg84ilbh2Query = { __typename?: 'Query', carAllPage: { __typename?: 'CarAllPage', id: string, carPosts: Array<{ __typename?: 'CarPost', id: string, href: string, type: CarPostType, images: Array<string>, price: number, publishedAt: string, voteCount: number, chatRoomCount: number, status: CarPostStatus, isInspected: boolean, driveDistance: number, user?: { __typename?: 'KarrotUser', dbId: string, nickname: string } | null, carData: { __typename?: 'CarData', carType: CarType, modelYear: number, options: string, carName: string, companyName?: string | null, carRegistrationYear?: number | null, fuelType?: FuelType | null, gear: Gear, carHistory?: { __typename?: 'CarHistory', accidentsCount?: number | null, ownerChangeCount?: number | null } | null }, leaseRentalInfo?: { __typename?: 'LeaseRentalInfo', monthlyFee?: number | null } | null, region: { __typename?: 'Region', name: string, name2?: string | null, name3?: string | null } }> } };

export type Pr98nul0z8knorpuyp4sw1zeQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['String']>;
  workPeriod?: InputMaybe<Scalars['String']>;
  tasks?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  workDays?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  workTime?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type Pr98nul0z8knorpuyp4sw1zeQuery = { __typename?: 'Query', jobsAllPage: { __typename?: 'JobsAllPage', id: string, jobPosts: Array<{ __typename?: 'JobPost', id: string, href: string, nodeId: string, title: string, acceptedAt?: string | null, content: string, salary: number, salaryType: SalaryType, images: Array<string>, workplaceCompanyName?: string | null, workplaceRoadNameAddress?: string | null, closed: boolean, isWorkTimeNegotiable?: boolean | null, workDays: Array<Day>, workDates: Array<string>, workTimeEnd: string, workTimeStart: string, reviewCount: number, badges: Array<Badge>, salaryPayMethod?: SalaryPayMethod | null, user?: { __typename?: 'KarrotUser', dbId: string, nickname: string } | null, workplaceRegion?: { __typename?: 'Region', name: string, nodeId: string, name1?: string | null, name2?: string | null } | null }> } };

export type RealtySquareThumbnailCard_RealtyPostFragment = { __typename?: 'RealtyPost', id: string, images: Array<string>, salesType: SalesTypeEnum, isWriterVerified?: boolean | null, isWriterVerifiedCorporate?: boolean | null, area?: string | null, areaPyeong?: string | null, supplyArea?: string | null, supplyAreaPyeong?: string | null, manageCost?: number | null, etcManageCost?: number | null, totalManageCost?: number | null, manageCostChargeType?: ManageCostChargeTypeEnum | null, excludeManageCostOption?: Array<ArticleManageCostOptionEnum> | null, isUnknownManageCost?: boolean | null, buildingName?: string | null, floor?: string | null, addressInfo: string, writerType: WriterTypeEnum, buildingApprovalDate?: string | null, createdAt: string, chatRoomCount: number, watchCount: number, trades: Array<{ __typename?: 'ArticleTrade', type: ArticleTradeType, preferred: boolean, manageCost?: number | null, deposit?: number | null, price?: number | null, monthlyPay?: number | null, yearlyPay?: number | null }>, includeManageCostOptionV2: Array<{ __typename?: 'IncludeManageCostOptionV2', payOption?: ManageCostPayOptionEnum | null, fixedCost?: number | null }>, includeManageCostOptionV3: Array<{ __typename?: 'IncludeManageCostOptionV3', payOption?: ManageCostPayOptionEnum | null, option: ArticleManageCostOptionEnum, fixedCost?: number | null, customOptionName?: string | null }>, region: { __typename?: 'Region', name: string } };

export type RealtyListJsonLd_RealtyPostFragment = { __typename?: 'RealtyPost', salesType: SalesTypeEnum, status: RealtyArticleStatusEnum, title: string, content: string, images: Array<string>, id: string, address: string, region: { __typename?: 'Region', name1?: string | null, name2?: string | null } };

export type Zcgsect6l5bunnl37biui3gzQueryVariables = Exact<{
  regionId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  salesType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tradeType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  monthMinPrice?: InputMaybe<Scalars['String']>;
  monthMaxPrice?: InputMaybe<Scalars['String']>;
  monthMinMonthlyPay?: InputMaybe<Scalars['String']>;
  monthMaxMonthlyPay?: InputMaybe<Scalars['String']>;
  borrowMinPrice?: InputMaybe<Scalars['String']>;
  borrowMaxPrice?: InputMaybe<Scalars['String']>;
  buyMinPrice?: InputMaybe<Scalars['String']>;
  buyMaxPrice?: InputMaybe<Scalars['String']>;
  yearMinPrice?: InputMaybe<Scalars['String']>;
  yearMaxPrice?: InputMaybe<Scalars['String']>;
  yearMinYearlyPay?: InputMaybe<Scalars['String']>;
  yearMaxYearlyPay?: InputMaybe<Scalars['String']>;
  shortMinPrice?: InputMaybe<Scalars['String']>;
  shortMaxPrice?: InputMaybe<Scalars['String']>;
  shortMinMonthlyPay?: InputMaybe<Scalars['String']>;
  shortMaxMonthlyPay?: InputMaybe<Scalars['String']>;
  floorFilters?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  options?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  minArea?: InputMaybe<Scalars['String']>;
  maxArea?: InputMaybe<Scalars['String']>;
  dealType?: InputMaybe<Scalars['String']>;
}>;


export type Zcgsect6l5bunnl37biui3gzQuery = { __typename?: 'Query', realtyPostsAllPage: { __typename?: 'RealtyPostsAllPage', id: string, realtyPosts: Array<{ __typename?: 'RealtyPost', title: string, images: Array<string>, id: string, salesType: SalesTypeEnum, isWriterVerified?: boolean | null, isWriterVerifiedCorporate?: boolean | null, area?: string | null, areaPyeong?: string | null, supplyArea?: string | null, supplyAreaPyeong?: string | null, manageCost?: number | null, etcManageCost?: number | null, totalManageCost?: number | null, manageCostChargeType?: ManageCostChargeTypeEnum | null, excludeManageCostOption?: Array<ArticleManageCostOptionEnum> | null, isUnknownManageCost?: boolean | null, buildingName?: string | null, floor?: string | null, addressInfo: string, writerType: WriterTypeEnum, buildingApprovalDate?: string | null, createdAt: string, chatRoomCount: number, watchCount: number, status: RealtyArticleStatusEnum, content: string, address: string, user?: { __typename?: 'KarrotUser', dbId: string } | null, trades: Array<{ __typename?: 'ArticleTrade', type: ArticleTradeType, preferred: boolean, manageCost?: number | null, deposit?: number | null, price?: number | null, monthlyPay?: number | null, yearlyPay?: number | null }>, includeManageCostOptionV2: Array<{ __typename?: 'IncludeManageCostOptionV2', payOption?: ManageCostPayOptionEnum | null, fixedCost?: number | null }>, includeManageCostOptionV3: Array<{ __typename?: 'IncludeManageCostOptionV3', payOption?: ManageCostPayOptionEnum | null, option: ArticleManageCostOptionEnum, fixedCost?: number | null, customOptionName?: string | null }>, region: { __typename?: 'Region', name: string, name1?: string | null, name2?: string | null } }> } };

export type UserProfileSummary_UserFragment = { __typename?: 'KarrotUser', id: string, profileImage: string, nickname: string, score: number, region: { __typename?: 'Region', name: string, dbId: string } };

export type CarTitleSection_CarPostFragment = { __typename?: 'CarPost', type: CarPostType, publishedAt: string, driveDistance: number, carData: { __typename?: 'CarData', carName: string, companyName?: string | null, modelYear: number, options: string, carHistory?: { __typename?: 'CarHistory', ownerChangeCount?: number | null } | null } };

export type PriceSection_CarPostFragment = { __typename?: 'CarPost', price: number, displacement?: number | null, driveDistance: number, carData: { __typename?: 'CarData', fuelType?: FuelType | null, modelYear: number } };

export type LeaseRentalSection_CarPostFragment = { __typename?: 'CarPost', type: CarPostType, driveDistance: number, carData: { __typename?: 'CarData', modelYear: number }, leaseRentalInfo?: { __typename?: 'LeaseRentalInfo', monthlyFee?: number | null, contractStartedAt: string, contractEndedAt: string, residualValue: number, acquisitionPrice: number, postContractOption: PostContractOption, deposit: number } | null };

export type PopularContentSection_CarPostFragment = { __typename?: 'CarPost', recommendedCarPosts: Array<{ __typename?: 'CarPost', id: string, images: Array<string>, driveDistance: number, content: string, type: CarPostType, price: number, status: CarPostStatus, isInspected: boolean, chatRoomCount: number, voteCount: number, publishedAt: string, region: { __typename?: 'Region', name: string }, carData: { __typename?: 'CarData', modelYear: number, companyName?: string | null, carName: string, options: string }, leaseRentalInfo?: { __typename?: 'LeaseRentalInfo', monthlyFee?: number | null } | null }> };

export type InformationSection_CarPostFragment = { __typename?: 'CarPost', driveDistance: number, displacement?: number | null, carData: { __typename?: 'CarData', carType: CarType, modelYear: number, carRegistrationYear?: number | null, carRegistrationMonth?: number | null, fuelType?: FuelType | null, gear: Gear, carHistory?: { __typename?: 'CarHistory', accidentsCount?: number | null, businessUsage?: string | null, ownerChangeCount?: number | null } | null } };

export type CarOptionsSection_CarPostFragment = { __typename?: 'CarPost', carData: { __typename?: 'CarData', options: string } };

export type AdditionalOptionSection_CarDataFragment = { __typename?: 'CarData', options: string, carHistory?: { __typename?: 'CarHistory', ownerChangeCount?: number | null } | null };

export type DetailContentSection_CarPostFragment = { __typename?: 'CarPost', content: string, viewCount: number, voteCount: number, chatRoomCount: number, coordinate?: { __typename?: 'Coordinates', lat: number, lon: number } | null, region: { __typename?: 'Region', name1?: string | null, name2?: string | null, name3?: string | null, name1Id?: { __typename?: 'Region', dbId: string } | null } };

export type Meta_CarPostFragment = { __typename?: 'CarPost', displacement?: number | null, driveDistance: number, content: string, region: { __typename?: 'Region', name: string }, carData: { __typename?: 'CarData', carType: CarType, carRegistrationYear?: number | null, carRegistrationMonth?: number | null, modelYear: number, gear: Gear, carHistory?: { __typename?: 'CarHistory', accidentsCount?: number | null } | null } };

export type G6c08376uwph7gra2kniw24sQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type G6c08376uwph7gra2kniw24sQuery = { __typename?: 'Query', carPost?: { __typename?: 'CarPost', id: string, dbId: string, status: CarPostStatus, nodeId: string, content: string, images: Array<string>, type: CarPostType, displacement?: number | null, driveDistance: number, publishedAt: string, price: number, viewCount: number, voteCount: number, chatRoomCount: number, user?: { __typename?: 'KarrotUser', dbId: string, id: string, profileImage: string, nickname: string, score: number, regionId: { __typename?: 'Region', name1Id?: { __typename?: 'Region', dbId: string } | null }, region: { __typename?: 'Region', name: string, dbId: string } } | null, carData: { __typename?: 'CarData', carName: string, companyName?: string | null, carType: CarType, carRegistrationYear?: number | null, carRegistrationMonth?: number | null, modelYear: number, gear: Gear, options: string, fuelType?: FuelType | null, carHistory?: { __typename?: 'CarHistory', accidentsCount?: number | null, ownerChangeCount?: number | null, businessUsage?: string | null } | null }, region: { __typename?: 'Region', name: string, name1?: string | null, name2?: string | null, name3?: string | null, name1Id?: { __typename?: 'Region', dbId: string } | null }, leaseRentalInfo?: { __typename?: 'LeaseRentalInfo', monthlyFee?: number | null, contractStartedAt: string, contractEndedAt: string, residualValue: number, acquisitionPrice: number, postContractOption: PostContractOption, deposit: number } | null, recommendedCarPosts: Array<{ __typename?: 'CarPost', id: string, images: Array<string>, driveDistance: number, content: string, type: CarPostType, price: number, status: CarPostStatus, isInspected: boolean, chatRoomCount: number, voteCount: number, publishedAt: string, region: { __typename?: 'Region', name: string }, carData: { __typename?: 'CarData', modelYear: number, companyName?: string | null, carName: string, options: string }, leaseRentalInfo?: { __typename?: 'LeaseRentalInfo', monthlyFee?: number | null } | null }>, coordinate?: { __typename?: 'Coordinates', lat: number, lon: number } | null } | null };

export type Meta_JobPostFragment = { __typename?: 'JobPost', title: string, workplaceCompanyName?: string | null, content: string, salary: number, salaryType: SalaryType, workplaceRegion?: { __typename?: 'Region', name: string } | null };

export type Ypzzpvtc24e8xqn4f7s54t97QueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Ypzzpvtc24e8xqn4f7s54t97Query = { __typename?: 'Query', jobPost?: { __typename?: 'JobPost', id: string, dbId: string, href: string, nodeId: string, appSchemePath: string, title: string, content: string, images: Array<string>, closed: boolean, workplaceCompanyName?: string | null, workplaceLotNumberAddress?: string | null, workplaceRoadNameAddress?: string | null, salary: number, salaryType: SalaryType, workDays: Array<Day>, workDates: Array<string>, workTimeEnd: string, workTimeStart: string, isWorkTimeNegotiable?: boolean | null, acceptedAt?: string | null, applicationCount: number, watchCount: number, reviewCount: number, badges: Array<Badge>, salaryPayMethod?: SalaryPayMethod | null, workplaceLocation?: { __typename?: 'WorkplaceLocation', lat?: number | null, lng?: number | null } | null, workplaceRegion?: { __typename?: 'Region', name: string, nodeId: string, name1?: string | null, name2?: string | null } | null, author?: { __typename?: 'KarrotUser', id: string, dbId: string, nickname: string, profileImage: string, score: number, region: { __typename?: 'Region', dbId: string, name: string } } | null, recommendedJobPosts: Array<{ __typename?: 'JobPost', id: string, href: string, nodeId: string, title: string, content: string, salary: number, salaryType: SalaryType, workplaceCompanyName?: string | null, images: Array<string>, acceptedAt?: string | null, workDates: Array<string>, workDays: Array<Day>, workTimeEnd: string, workTimeStart: string, isWorkTimeNegotiable?: boolean | null, reviewCount: number, badges: Array<Badge>, workplaceRegion?: { __typename?: 'Region', name: string } | null }> } | null };

export type BrokerProfileSummary_RealtyBrokerBusinessProfileFragment = { __typename?: 'RealtyBrokerBusinessProfile', id: string, originalId: string, name: string, thumbImageUrl: string, status: RealtyBrokerBusinessProfileStatusEnum, businessRegistrationNumber: string, licenseRegistrationNumber: string, licenseOwnerContact: string, licenseOwnerName: string, jibunAddress: string, roadAddress: string, createdAt: string, businessProfile: { __typename?: 'LocalProfile', id: string, region?: { __typename?: 'Region', name: string, dbId: string } | null } };

export type RealtyTitleSection_RealtyPostFragment = { __typename?: 'RealtyPost', title: string, writerType: WriterTypeEnum, salesType: SalesTypeEnum, status: RealtyArticleStatusEnum, createdAt: string, trades: Array<{ __typename: 'ArticleTrade', type: ArticleTradeType, preferred: boolean, deposit?: number | null, monthlyPay?: number | null, yearlyPay?: number | null, price?: number | null }> };

export type InformationSection_RealtyPostFragment = { __typename?: 'RealtyPost', dbId: string, buildingUsage?: BuildingUsageEnum | null, buildingOrientation?: ArticleBuildingOrientationEnum | null, buildingApprovalDate?: string | null, buildingName?: string | null, area?: string | null, areaPyeong?: string | null, supplyArea?: string | null, supplyAreaPyeong?: string | null, roomCnt?: number | null, bathroomCnt?: number | null, floor?: string | null, topFloor?: string | null, content: string, manageCost?: number | null, etcManageCost?: number | null, totalManageCost?: number | null, isUnknownManageCost?: boolean | null, isWriterVerified?: boolean | null, isWriterVerifiedCorporate?: boolean | null, excludeManageCostOption?: Array<ArticleManageCostOptionEnum> | null, manageCostChargeType?: ManageCostChargeTypeEnum | null, manageCostEtcChargeBasis?: ManageCostEtcChargeBasisEnum | null, manageCostUnavailableReason?: ManageCostUnavailableReasonEnum | null, manageCostDetailIsDisclosed?: boolean | null, manageCostCalculationPeriod?: ManageCostCalculationPeriodEnum | null, manageCostEtcChargeBasisCustom?: string | null, manageCostCalculationPeriodCustom?: string | null, moveInDate?: string | null, address: string, addressInfo: string, watchCount: number, viewCount: number, chatRoomCount: number, writerType: WriterTypeEnum, appSchemaPath: string, availableParkingSpots?: number | null, availableParkingSpotsV2?: number | null, availableTotalParkingSpots?: number | null, trades: Array<{ __typename: 'ArticleTrade', type: ArticleTradeType, preferred: boolean, manageCost?: number | null, manageCostDescription?: string | null }>, includeManageCostOptionV2: Array<{ __typename?: 'IncludeManageCostOptionV2', fixedCost?: number | null, payOption?: ManageCostPayOptionEnum | null, option: ArticleManageCostOptionEnum }>, includeManageCostOptionV3: Array<{ __typename?: 'IncludeManageCostOptionV3', fixedCost?: number | null, payOption?: ManageCostPayOptionEnum | null, option: ArticleManageCostOptionEnum, customOptionName?: string | null }>, options: Array<{ __typename?: 'ArticleOption', name: ArticleOptionNameEnum, value: ArticleOptionValueEnum }>, coordinate: { __typename?: 'RealtyCoordinates', lat: string, lon: string } };

export type PopularContentSection_RealtyPostFragment = { __typename?: 'RealtyPost', recommendedRealtyPosts: Array<{ __typename?: 'RealtyPost', id: string, title: string, images: Array<string>, salesType: SalesTypeEnum, area?: string | null, areaPyeong?: string | null, supplyArea?: string | null, etcManageCost?: number | null, totalManageCost?: number | null, isUnknownManageCost?: boolean | null, manageCostChargeType?: ManageCostChargeTypeEnum | null, buildingName?: string | null, floor?: string | null, addressInfo: string, writerType: WriterTypeEnum, buildingApprovalDate?: string | null, createdAt: string, chatRoomCount: number, watchCount: number, trades: Array<{ __typename?: 'ArticleTrade', type: ArticleTradeType, preferred: boolean, manageCost?: number | null, deposit?: number | null, price?: number | null, monthlyPay?: number | null }>, includeManageCostOptionV2: Array<{ __typename?: 'IncludeManageCostOptionV2', payOption?: ManageCostPayOptionEnum | null, fixedCost?: number | null }>, includeManageCostOptionV3: Array<{ __typename?: 'IncludeManageCostOptionV3', payOption?: ManageCostPayOptionEnum | null, fixedCost?: number | null, option: ArticleManageCostOptionEnum, customOptionName?: string | null }>, region: { __typename?: 'Region', name: string } }> };

export type Meta_RealtyPostFragment = { __typename?: 'RealtyPost', title: string, buildingName?: string | null, addressInfo: string, area?: string | null, areaPyeong?: string | null, roomCnt?: number | null, bathroomCnt?: number | null, floor?: string | null, topFloor?: string | null, content: string, moveInDate?: string | null, trades: Array<{ __typename?: 'ArticleTrade', preferred: boolean, type: ArticleTradeType, price?: number | null, monthlyPay?: number | null, deposit?: number | null, yearlyPay?: number | null }>, region: { __typename?: 'Region', name: string }, options: Array<{ __typename?: 'ArticleOption', name: ArticleOptionNameEnum, value: ArticleOptionValueEnum }> };

export type Za56cgc4gyr9xkjpb9mxas65QueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Za56cgc4gyr9xkjpb9mxas65Query = { __typename?: 'Query', realtyPost?: { __typename?: 'RealtyPost', id: string, dbId: string, nodeId: string, href: string, title: string, appSchemaPath: string, images: Array<string>, salesType: SalesTypeEnum, isWriterVerified?: boolean | null, writerType: WriterTypeEnum, writerTypeText?: string | null, createdAt: string, chatRoomCount: number, watchCount: number, viewCount: number, content: string, address: string, addressInfo: string, status: RealtyArticleStatusEnum, buildingName?: string | null, area?: string | null, areaPyeong?: string | null, roomCnt?: number | null, bathroomCnt?: number | null, floor?: string | null, topFloor?: string | null, moveInDate?: string | null, buildingUsage?: BuildingUsageEnum | null, buildingOrientation?: ArticleBuildingOrientationEnum | null, buildingApprovalDate?: string | null, supplyArea?: string | null, supplyAreaPyeong?: string | null, manageCost?: number | null, etcManageCost?: number | null, totalManageCost?: number | null, isUnknownManageCost?: boolean | null, isWriterVerifiedCorporate?: boolean | null, excludeManageCostOption?: Array<ArticleManageCostOptionEnum> | null, manageCostChargeType?: ManageCostChargeTypeEnum | null, manageCostEtcChargeBasis?: ManageCostEtcChargeBasisEnum | null, manageCostUnavailableReason?: ManageCostUnavailableReasonEnum | null, manageCostDetailIsDisclosed?: boolean | null, manageCostCalculationPeriod?: ManageCostCalculationPeriodEnum | null, manageCostEtcChargeBasisCustom?: string | null, manageCostCalculationPeriodCustom?: string | null, availableParkingSpots?: number | null, availableParkingSpotsV2?: number | null, availableTotalParkingSpots?: number | null, trades: Array<{ __typename: 'ArticleTrade', type: ArticleTradeType, preferred: boolean, manageCost?: number | null, manageCostDescription?: string | null, deposit?: number | null, description?: string | null, adjustable?: boolean | null, price?: number | null, monthlyPay?: number | null, yearlyPay?: number | null }>, region: { __typename?: 'Region', name: string, name1?: string | null, name2?: string | null }, author?: { __typename?: 'KarrotUser', dbId: string, id: string, profileImage: string, nickname: string, score: number, region: { __typename?: 'Region', name: string, dbId: string } } | null, brokerProfile?: { __typename?: 'RealtyBrokerBusinessProfile', id: string, originalId: string, name: string, thumbImageUrl: string, status: RealtyBrokerBusinessProfileStatusEnum, businessRegistrationNumber: string, licenseRegistrationNumber: string, licenseOwnerContact: string, licenseOwnerName: string, jibunAddress: string, roadAddress: string, createdAt: string, businessProfile: { __typename?: 'LocalProfile', id: string, region?: { __typename?: 'Region', name: string, dbId: string } | null } } | null, coordinate: { __typename?: 'RealtyCoordinates', lat: string, lon: string }, options: Array<{ __typename?: 'ArticleOption', name: ArticleOptionNameEnum, value: ArticleOptionValueEnum }>, includeManageCostOptionV2: Array<{ __typename?: 'IncludeManageCostOptionV2', fixedCost?: number | null, payOption?: ManageCostPayOptionEnum | null, option: ArticleManageCostOptionEnum }>, includeManageCostOptionV3: Array<{ __typename?: 'IncludeManageCostOptionV3', fixedCost?: number | null, payOption?: ManageCostPayOptionEnum | null, option: ArticleManageCostOptionEnum, customOptionName?: string | null }>, recommendedRealtyPosts: Array<{ __typename?: 'RealtyPost', id: string, title: string, images: Array<string>, salesType: SalesTypeEnum, area?: string | null, areaPyeong?: string | null, supplyArea?: string | null, etcManageCost?: number | null, totalManageCost?: number | null, isUnknownManageCost?: boolean | null, manageCostChargeType?: ManageCostChargeTypeEnum | null, buildingName?: string | null, floor?: string | null, addressInfo: string, writerType: WriterTypeEnum, buildingApprovalDate?: string | null, createdAt: string, chatRoomCount: number, watchCount: number, trades: Array<{ __typename?: 'ArticleTrade', type: ArticleTradeType, preferred: boolean, manageCost?: number | null, deposit?: number | null, price?: number | null, monthlyPay?: number | null }>, includeManageCostOptionV2: Array<{ __typename?: 'IncludeManageCostOptionV2', payOption?: ManageCostPayOptionEnum | null, fixedCost?: number | null }>, includeManageCostOptionV3: Array<{ __typename?: 'IncludeManageCostOptionV3', payOption?: ManageCostPayOptionEnum | null, fixedCost?: number | null, option: ArticleManageCostOptionEnum, customOptionName?: string | null }>, region: { __typename?: 'Region', name: string } }> } | null };

export type Ozmer9kxsuvxqvu3zzp7rv5lQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  themeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  hasAvailableCouponBoxes?: InputMaybe<Scalars['Boolean']>;
  reservable?: InputMaybe<Scalars['Boolean']>;
  onSale?: InputMaybe<Scalars['Boolean']>;
}>;


export type Ozmer9kxsuvxqvu3zzp7rv5lQuery = { __typename?: 'Query', localProfileAllPage: { __typename?: 'LocalProfileAllPage', id: string, localProfiles: Array<{ __typename?: 'CCLocalProfile', id: string, name: string, description: string, starRating: number, reviewCount: number, isReservable: boolean, hasUsableCoupon: boolean, isStoreOnSale: boolean, followersCount: number, permalink: string, jibunAddress?: string | null, roadAddress?: string | null, profilePicture?: { __typename?: 'Image', url: string } | null, category?: { __typename?: 'LocalProfileCategory', name: string, levels: Array<string> } | null, region?: { __typename?: 'Region', name: string, name1?: string | null, name2?: string | null, name3?: string | null } | null }> } };

export type Qsctju297zotwojxqfpqpib9QueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type Qsctju297zotwojxqfpqpib9Query = { __typename?: 'Query', communityGroupAllPage: { __typename?: 'CommunityGroupAllPage', id: string, communityGroups: Array<{ __typename?: 'CommunityGroup', id: string, name: string, profileImage: string, description: string, memberCount: number, categoryName: string, region: { __typename?: 'Region', name: string } }> } };

export type Blawcx3ht8trkvg1evh33fnhQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Blawcx3ht8trkvg1evh33fnhQuery = { __typename?: 'Query', communityGroup?: { __typename?: 'CommunityGroup', id: string, dbId: string, name: string, appScheme: string, backgroundImage: string, profileImage: string, description: string, memberCount: number, postCount: number, meetupCount: number, lastActivatedAt: string, categoryName: string, ageRange?: string | null, photoImages: Array<string>, favoriteLocationPlaceTag?: { __typename?: 'PlaceTag', name: string, coordinate: { __typename?: 'PlaceTagCoordinates', lat: number, lon: number } } | null, region: { __typename?: 'Region', name: string, name1?: string | null, name2?: string | null, name3?: string | null }, boardCategories: Array<{ __typename?: 'CommunityGroupBoardCategory', categoryName: string, posts: Array<{ __typename?: 'CommunityGroupPost', id: string, content: string, categoryName: string, authorName: string, firstImage?: string | null, emotionCount: number, commentCount: number, groupOnly: boolean, createdAt: string } | null> }>, members: Array<{ __typename?: 'CommunityGroupMember', profileImage: string, nickname: string, description: string, role: GroupMemberRole, region: { __typename?: 'Region', name: string } }>, meetups: Array<{ __typename?: 'CommunityGroupMeetup', id: string, name: string, image?: string | null, groupOnly: boolean, progressStatus: CommunityGroupMeetupProgressStatus, currentParticipantsNumber: number, maximumParticipantsNumber: number, meetAt: string, placeTag?: { __typename?: 'PlaceTag', name: string, addressText?: string | null, coordinate: { __typename?: 'PlaceTagCoordinates', lat: number, lon: number }, region?: { __typename?: 'Region', name1?: string | null, name2?: string | null } | null } | null }> } | null };

export type MemberSection_CommunityGroupFragment = { __typename?: 'CommunityGroup', members: Array<{ __typename?: 'CommunityGroupMember', profileImage: string, nickname: string, description: string, role: GroupMemberRole, region: { __typename?: 'Region', name: string } }> };

export type BoardCategoryPostSection_CommunityGroupBoardCategoryFragment = { __typename?: 'CommunityGroupBoardCategory', posts: Array<{ __typename?: 'CommunityGroupPost', id: string, content: string, categoryName: string, authorName: string, firstImage?: string | null, emotionCount: number, commentCount: number, groupOnly: boolean, createdAt: string } | null> };

export type MeetupSection_CommunityGroupFragment = { __typename?: 'CommunityGroup', meetups: Array<{ __typename?: 'CommunityGroupMeetup', id: string, name: string, image?: string | null, groupOnly: boolean, progressStatus: CommunityGroupMeetupProgressStatus, currentParticipantsNumber: number, maximumParticipantsNumber: number, meetAt: string, placeTag?: { __typename?: 'PlaceTag', name: string, addressText?: string | null, coordinate: { __typename?: 'PlaceTagCoordinates', lat: number, lon: number }, region?: { __typename?: 'Region', name1?: string | null, name2?: string | null } | null } | null }> };

export type SquareThumbnailCard_CommunityArticlesFragment = { __typename?: 'CommunityArticle', title: string, content: string, regionName: string, subject: string, createdAt?: string | null, commentsCount: number, imageUrls?: Array<string> | null, emotionCount: number };

export type CommunityListJsonLd_CommunityArticlesFragment = { __typename?: 'CommunityArticle', title: string, content: string, createdAt?: string | null, updatedAt?: string | null, imageUrls?: Array<string> | null, emotionCount: number, commentsCount: number, writer: { __typename?: 'CommunityAgoraContentsWriter', nickName: string } };

export type Y289z6x54ytv9lzj6z38ov2zQueryVariables = Exact<{
  regionId: Scalars['String'];
  categoryId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type Y289z6x54ytv9lzj6z38ov2zQuery = { __typename?: 'Query', communityArticleAllPage: { __typename?: 'CommunityArticleAllPage', communityArticles: Array<{ __typename?: 'CommunityArticle', id: string, title: string, content: string, regionName: string, subject: string, createdAt?: string | null, commentsCount: number, imageUrls?: Array<string> | null, emotionCount: number, updatedAt?: string | null, writer: { __typename?: 'CommunityAgoraContentsWriter', nickName: string } }> } };

export type Cfm8bhvgmz3luoz0vnj0jjcjQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Cfm8bhvgmz3luoz0vnj0jjcjQuery = { __typename?: 'Query', communityArticle?: { __typename?: 'CommunityArticle', id: string, href: string, dbId: string, nodeId: string, regionName: string, subjectId: string, subject: string, title: string, content: string, status: CommunityArticleAndCommentStatus, createdAt?: string | null, updatedAt?: string | null, imageUrls?: Array<string> | null, autoHashtags?: Array<string> | null, commentsCount: number, emotionCount: number, readsCount: number, watchesCount: number, emotionSummaryMoveToAppTargetUrl: string, emotionMoveToAppTargetUrl: string, commentMoveToAppTargetUrl: string, watchedMoveToAppTargetUrl: string, writer: { __typename?: 'CommunityAgoraContentsWriter', userStatus: CommunityContentsWriterStatus, nickName: string, profileImageUrl?: string | null, userTemperature?: number | null, writeRegionName?: string | null, moveToAppTargetUrl?: string | null }, emotionDetails?: Array<{ __typename?: 'CommunityAgoraEmotionDetail', kind: string, count: number }> | null, poll?: { __typename?: 'CommunityArticlePoll', enableMultipleChoice: string, totalVoteCount: number, totalVoterCount: number, moveToAppTargetUrl: string, options?: Array<{ __typename?: 'CommunityArticlePollOption', title: string, voteCount: number }> | null } | null, placeTag?: { __typename?: 'CommunityAgoraPlaceTag', placeTagId?: number | null, placeTagType?: string | null, placeTagTitle?: string | null, placeTagCategory?: string | null, placeTagLatitude?: number | null, placeTagLongitude?: number | null, totalReviewCount?: number | null, address?: string | null, jibunAddress?: string | null } | null, comments: { __typename?: 'CommunityArticleComments', visibleMoreCommentView: boolean, moreCommentsMoveToAppTargetUrl: string, writeCommentsMoveToAppTargetUrl: string, commentEmotionMoveToAppTargetUrl: string, subCommentsMoveToAppTargetUrl: string, createdSortedComments: Array<{ __typename?: 'CommunityArticleComment', id: string, articleId: string, parentCommentId?: string | null, status: CommunityArticleAndCommentStatus, content: string, imageUrl?: string | null, createdAt?: string | null, subComments?: Array<{ __typename?: 'CommunityArticleComment', id: string, articleId: string, parentCommentId?: string | null, status: CommunityArticleAndCommentStatus, content: string, imageUrl?: string | null, createdAt?: string | null, writer: { __typename?: 'CommunityAgoraContentsWriter', userStatus: CommunityContentsWriterStatus, nickName: string, profileImageUrl?: string | null, userTemperature?: number | null, writeRegionName?: string | null, moveToAppTargetUrl?: string | null }, emotionCounts?: Array<{ __typename?: 'CommunityAgoraEmotionDetail', kind: string, count: number }> | null, placeTag?: { __typename?: 'CommunityAgoraPlaceTag', placeTagId?: number | null, placeTagType?: string | null, placeTagTitle?: string | null, placeTagCategory?: string | null, placeTagLatitude?: number | null, placeTagLongitude?: number | null, totalReviewCount?: number | null, address?: string | null, jibunAddress?: string | null } | null }> | null, writer: { __typename?: 'CommunityAgoraContentsWriter', userStatus: CommunityContentsWriterStatus, nickName: string, profileImageUrl?: string | null, userTemperature?: number | null, writeRegionName?: string | null, moveToAppTargetUrl?: string | null }, emotionCounts?: Array<{ __typename?: 'CommunityAgoraEmotionDetail', kind: string, count: number }> | null, placeTag?: { __typename?: 'CommunityAgoraPlaceTag', placeTagId?: number | null, placeTagType?: string | null, placeTagTitle?: string | null, placeTagCategory?: string | null, placeTagLatitude?: number | null, placeTagLongitude?: number | null, totalReviewCount?: number | null, address?: string | null, jibunAddress?: string | null } | null }>, recentSortedComments: Array<{ __typename?: 'CommunityArticleComment', id: string, articleId: string, parentCommentId?: string | null, status: CommunityArticleAndCommentStatus, content: string, imageUrl?: string | null, createdAt?: string | null, subComments?: Array<{ __typename?: 'CommunityArticleComment', id: string, articleId: string, parentCommentId?: string | null, status: CommunityArticleAndCommentStatus, content: string, imageUrl?: string | null, createdAt?: string | null, writer: { __typename?: 'CommunityAgoraContentsWriter', userStatus: CommunityContentsWriterStatus, nickName: string, profileImageUrl?: string | null, userTemperature?: number | null, writeRegionName?: string | null, moveToAppTargetUrl?: string | null }, emotionCounts?: Array<{ __typename?: 'CommunityAgoraEmotionDetail', kind: string, count: number }> | null, placeTag?: { __typename?: 'CommunityAgoraPlaceTag', placeTagId?: number | null, placeTagType?: string | null, placeTagTitle?: string | null, placeTagCategory?: string | null, placeTagLatitude?: number | null, placeTagLongitude?: number | null, totalReviewCount?: number | null, address?: string | null, jibunAddress?: string | null } | null }> | null, writer: { __typename?: 'CommunityAgoraContentsWriter', userStatus: CommunityContentsWriterStatus, nickName: string, profileImageUrl?: string | null, userTemperature?: number | null, writeRegionName?: string | null, moveToAppTargetUrl?: string | null }, emotionCounts?: Array<{ __typename?: 'CommunityAgoraEmotionDetail', kind: string, count: number }> | null, placeTag?: { __typename?: 'CommunityAgoraPlaceTag', placeTagId?: number | null, placeTagType?: string | null, placeTagTitle?: string | null, placeTagCategory?: string | null, placeTagLatitude?: number | null, placeTagLongitude?: number | null, totalReviewCount?: number | null, address?: string | null, jibunAddress?: string | null } | null }> }, recommendedArticles?: Array<{ __typename?: 'CommunityRecommendedArticle', id: string, title: string, content: string, subject: string, regionName?: string | null, image?: string | null, commentsCount?: number | null, emotionsCount?: number | null, permalink: string, createdAt?: string | null }> | null } | null };

export type CommunityAgoraContentsWriter_CommunityAgoraPageFragment = { __typename?: 'CommunityAgoraContentsWriter', userStatus: CommunityContentsWriterStatus, nickName: string, profileImageUrl?: string | null, userTemperature?: number | null, writeRegionName?: string | null, moveToAppTargetUrl?: string | null };

export type CommunityAgoraPlaceTag_CommunityAgoraPageFragment = { __typename?: 'CommunityAgoraPlaceTag', placeTagId?: number | null, placeTagType?: string | null, placeTagTitle?: string | null, placeTagCategory?: string | null, placeTagLatitude?: number | null, placeTagLongitude?: number | null, totalReviewCount?: number | null, address?: string | null, jibunAddress?: string | null };

export type CommunityArticlePoll_CommunityAgoraPageFragment = { __typename?: 'CommunityArticlePoll', enableMultipleChoice: string, totalVoteCount: number, totalVoterCount: number, moveToAppTargetUrl: string, options?: Array<{ __typename?: 'CommunityArticlePollOption', title: string, voteCount: number }> | null };

export type CommunityArticleComment_CommunityAgoraPageFragment = { __typename?: 'CommunityArticleComment', id: string, articleId: string, parentCommentId?: string | null, status: CommunityArticleAndCommentStatus, content: string, imageUrl?: string | null, createdAt?: string | null, writer: { __typename?: 'CommunityAgoraContentsWriter', userStatus: CommunityContentsWriterStatus, nickName: string, profileImageUrl?: string | null, userTemperature?: number | null, writeRegionName?: string | null, moveToAppTargetUrl?: string | null }, emotionCounts?: Array<{ __typename?: 'CommunityAgoraEmotionDetail', kind: string, count: number }> | null, placeTag?: { __typename?: 'CommunityAgoraPlaceTag', placeTagId?: number | null, placeTagType?: string | null, placeTagTitle?: string | null, placeTagCategory?: string | null, placeTagLatitude?: number | null, placeTagLongitude?: number | null, totalReviewCount?: number | null, address?: string | null, jibunAddress?: string | null } | null };

export type CommunityRecommendedArticle_CommunityAgoraPageFragment = { __typename?: 'CommunityRecommendedArticle', id: string, title: string, content: string, subject: string, regionName?: string | null, image?: string | null, commentsCount?: number | null, emotionsCount?: number | null, permalink: string, createdAt?: string | null };

export type Itzo80tst68gdzsh2dl4tbxpQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Itzo80tst68gdzsh2dl4tbxpQuery = { __typename?: 'Query', pickupQr?: { __typename?: 'PickupQR', id: string, url?: string | null, storeId?: string | null, meta?: { __typename?: 'MetaData', imageUrl?: string | null, title?: string | null, description?: string | null } | null } | null };

export type Fe63ywhpa7ybi8wtiaf934ouQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Fe63ywhpa7ybi8wtiaf934ouQuery = { __typename?: 'Query', expertQr?: { __typename?: 'ExpertQR', id: string, url?: string | null, businessAccountId?: number | null } | null };


export type JampotFetchOptions = {
  headers?: Headers,
}

export type HomePageQueryVariables = T1f4rroyh8g2no4lc5sqts7cQueryVariables;
export type AllPageQueryVariables = Mi8bgungqt1x8yv90we35urfQueryVariables;
export type RegionPageQueryVariables = Matd7o4pbwa78imhrveh8a8oQueryVariables;
export type UserPageQueryVariables = Rsu5tqudsype0qpq7d75w2qpQueryVariables;
export type FleamarketArticlePageQueryVariables = Vq3t1l3qhxp9vm4z028a5f5wQueryVariables;
export type CategoriesPageQueryVariables = Ke67vlmxclra2bg8nfxz426qQueryVariables;
export type PageLocalProfileQueryQueryVariables = Kivgs9on2s6vovm73dtpyi7vQueryVariables;
export type PageBusinessPostQueryQueryVariables = G9gp1qipve6s9bw790vcs9x5QueryVariables;
export type CarAllPageQueryVariables = Gfo93obxz2wx9y6kg84ilbh2QueryVariables;
export type JobsAllPageQueryVariables = Pr98nul0z8knorpuyp4sw1zeQueryVariables;
export type RealtyPostsAllPageQueryVariables = Zcgsect6l5bunnl37biui3gzQueryVariables;
export type CarPostKrCarPostsCarPostIdQueryVariables = G6c08376uwph7gra2kniw24sQueryVariables;
export type JobPostPageQueryVariables = Ypzzpvtc24e8xqn4f7s54t97QueryVariables;
export type RealtyPostsKrRealtyPostsRealtyPostIdQueryVariables = Za56cgc4gyr9xkjpb9mxas65QueryVariables;
export type LocalProfileAllPageQueryVariables = Ozmer9kxsuvxqvu3zzp7rv5lQueryVariables;
export type CommunityGroupAllPageQueryVariables = Qsctju297zotwojxqfpqpib9QueryVariables;
export type PageCommunityGroupsQueryQueryVariables = Blawcx3ht8trkvg1evh33fnhQueryVariables;
export type CommunityAgoraQueryPageQueryVariables = Y289z6x54ytv9lzj6z38ov2zQueryVariables;
export type CommunityAgoraPageQueryVariables = Cfm8bhvgmz3luoz0vnj0jjcjQueryVariables;
export type PickupQrQueryVariables = Itzo80tst68gdzsh2dl4tbxpQueryVariables;
export type ExpertQrQueryVariables = Fe63ywhpa7ybi8wtiaf934ouQueryVariables;

export type Jampot = {
  fetch(
      urlPattern: "/:c(/)",
      variables: T1f4rroyh8g2no4lc5sqts7cQueryVariables & { c: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: T1f4rroyh8g2no4lc5sqts7cQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/buy-sell(/)",
      variables: Mi8bgungqt1x8yv90we35urfQueryVariables & { c: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Mi8bgungqt1x8yv90we35urfQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/regions/(:name-):id(/)",
      variables: Matd7o4pbwa78imhrveh8a8oQueryVariables & { c: string; id: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Matd7o4pbwa78imhrveh8a8oQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/users/(:nickname-):nodeId(/)",
      variables: Rsu5tqudsype0qpq7d75w2qpQueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Rsu5tqudsype0qpq7d75w2qpQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/buy-sell/(:title-):nodeId(/)",
      variables: Vq3t1l3qhxp9vm4z028a5f5wQueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Vq3t1l3qhxp9vm4z028a5f5wQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/buy-sell/categories(/)",
      variables: { c: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Ke67vlmxclra2bg8nfxz426qQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/local-profile/(:name-):nodeId(/)",
      variables: Kivgs9on2s6vovm73dtpyi7vQueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Kivgs9on2s6vovm73dtpyi7vQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/business-post/(:title-):nodeId(/)",
      variables: G9gp1qipve6s9bw790vcs9x5QueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: G9gp1qipve6s9bw790vcs9x5Query, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/cars(/)",
      variables: Gfo93obxz2wx9y6kg84ilbh2QueryVariables & { c: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Gfo93obxz2wx9y6kg84ilbh2Query, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/jobs(/)",
      variables: Pr98nul0z8knorpuyp4sw1zeQueryVariables & { c: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Pr98nul0z8knorpuyp4sw1zeQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/kr/realty(/)",
      variables: Zcgsect6l5bunnl37biui3gzQueryVariables & {  },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Zcgsect6l5bunnl37biui3gzQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/cars/(:title-):nodeId(/)",
      variables: G6c08376uwph7gra2kniw24sQueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: G6c08376uwph7gra2kniw24sQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/jobs/(:title-):nodeId(/)",
      variables: Ypzzpvtc24e8xqn4f7s54t97QueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Ypzzpvtc24e8xqn4f7s54t97Query, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/realty/(:title-):nodeId(/)",
      variables: Za56cgc4gyr9xkjpb9mxas65QueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Za56cgc4gyr9xkjpb9mxas65Query, extensions?: any } | null>;
  fetch(
      urlPattern: "/kr/local-profile(/)",
      variables: Ozmer9kxsuvxqvu3zzp7rv5lQueryVariables & {  },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Ozmer9kxsuvxqvu3zzp7rv5lQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/kr/group(/)",
      variables: Qsctju297zotwojxqfpqpib9QueryVariables & {  },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Qsctju297zotwojxqfpqpib9Query, extensions?: any } | null>;
  fetch(
      urlPattern: "/kr/group/(:title-):nodeId(/)",
      variables: Blawcx3ht8trkvg1evh33fnhQueryVariables & { nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Blawcx3ht8trkvg1evh33fnhQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/kr/community(/)",
      variables: Y289z6x54ytv9lzj6z38ov2zQueryVariables & {  },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Y289z6x54ytv9lzj6z38ov2zQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/kr/community/(:title-):nodeId(/)",
      variables: Cfm8bhvgmz3luoz0vnj0jjcjQueryVariables & { nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Cfm8bhvgmz3luoz0vnj0jjcjQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/kr/pickup-qr/:nodeId(/)",
      variables: Itzo80tst68gdzsh2dl4tbxpQueryVariables & { nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Itzo80tst68gdzsh2dl4tbxpQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/kr/expert-qr/:nodeId(/)",
      variables: Fe63ywhpa7ybi8wtiaf934ouQueryVariables & { nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Fe63ywhpa7ybi8wtiaf934ouQuery, extensions?: any } | null>;
};

const queryHashes: {
  [urlPattern: string]: string | undefined
} = {
    ["/:c(/)"]: "8fd1e4e3625deb8c1e99a0396ce524b4",
    ["/:c/buy-sell(/)"]: "908885b55cdbee1b409b7399e62f7410",
    ["/:c/regions/(:name-):id(/)"]: "835eb9b571de1f5750e0acde26345b0f",
    ["/:c/users/(:nickname-):nodeId(/)"]: "08c5c8f12889e787f58d0768b4827ea8",
    ["/:c/buy-sell/(:title-):nodeId(/)"]: "246064012810a882c870d2f189681747",
    ["/:c/buy-sell/categories(/)"]: "9472bc92188a6d82db52212e35af997d",
    ["/:c/local-profile/(:name-):nodeId(/)"]: "a8410f082676aa0cdea17d83268412f1",
    ["/:c/business-post/(:title-):nodeId(/)"]: "f69652e7e873a595e8536d936a04a802",
    ["/:c/cars(/)"]: "19d432dad48a4fcd810ef1adcdec80e6",
    ["/:c/jobs(/)"]: "a1b58f795fd81545b9c870a11dac6ee1",
    ["/kr/realty(/)"]: "6240c37179577d2970733f2c6793c48e",
    ["/:c/cars/(:title-):nodeId(/)"]: "fef65e5d8c791fe1500996dfa2b5c3c3",
    ["/:c/jobs/(:title-):nodeId(/)"]: "22638eba2d63b2fbc09932f5a1e8bde0",
    ["/:c/realty/(:title-):nodeId(/)"]: "3cf8b20ba0ed060af5d209443d735167",
    ["/kr/local-profile(/)"]: "c5e24e5a5d45d3d747212238fe7bfc80",
    ["/kr/group(/)"]: "581b617ff6b5a5d41014b03f5fc55754",
    ["/kr/group/(:title-):nodeId(/)"]: "8eee48b957d9316b2d6691d1cfcf72d9",
    ["/kr/community(/)"]: "f2e474cd57427e534d662e3e18bb87ca",
    ["/kr/community/(:title-):nodeId(/)"]: "f1859e355ab121f648c754c823346f8d",
    ["/kr/pickup-qr/:nodeId(/)"]: "11f9c21736c9e1764a6715998e1390a6",
    ["/kr/expert-qr/:nodeId(/)"]: "ce97b91870a2ae2f8222f8fde8677a65",
};

function pathToUrl(path: string) {
  return new URL(path, "file://");
}

function urlSearchParamsToMap(urlSearchParams: URLSearchParams) {
  const map: { [key: string]: any } = {};

  urlSearchParams.forEach((value, key) => {
    map[key] = value;
  });

  return map;
}

function appendTrailingSlashInPathname(pathname: string) {
  if (pathname.endsWith("/")) {
    return pathname;
  }
  return `${pathname}/`;
}

function prependQuestionMarkInSearchParams(searchParams: URLSearchParams) {
  const searchParamsStr = searchParams.toString();

  if (searchParamsStr.length > 0) {
    return `?${searchParams}`;
  }
  return searchParams;
}

/**
 * import { UrlPatternOptions } from "url-pattern"
 */
export interface UrlPatternOptions {
  escapeChar?: string;
  segmentNameStartChar?: string;
  segmentValueCharset?: string;
  segmentNameCharset?: string;
  optionalSegmentStartChar?: string;
  optionalSegmentEndChar?: string;
  wildcardChar?: string;
}

export function makeTemplate(
  templateStr: string,
  urlPatternOptions?: UrlPatternOptions,
) {
  const pattern = new UrlPattern(`${templateStr}(/)`, urlPatternOptions);

  return {
    fill(params: { [key: string]: string | undefined }): string | null {
      const pathname = pattern.stringify(params);
      const pathParams = pattern.match(pathname);

      const searchParamsMap = { ...params };

      if (!pathParams) {
        return null;
      }

      Object.keys(pathParams).forEach((key) => {
        delete searchParamsMap[key];
      });

      const searchParams = new URLSearchParams(
        Object.entries(searchParamsMap).reduce(
          (acc, [key, value]) => ({
            ...acc,
            ...(value
              ? {
                  [key]: value,
                }
              : null),
          }),
          {} as Record<string, string>,
        ),
      );

      return (
        appendTrailingSlashInPathname(pathname) +
        prependQuestionMarkInSearchParams(searchParams)
      );
    },
    parse<T extends { [key: string]: string | undefined }>(
      path: string,
    ): T | null {
      const url = pathToUrl(path);
      const pathParams = pattern.match(url.pathname);
      const searchParams = urlSearchParamsToMap(url.searchParams);

      if (!pathParams) {
        return null;
      }

      return {
        ...searchParams,
        ...pathParams,
      };
    },
  };
}

export function jampot(options?: { fetch?: any }): Jampot {
  return {
    async fetch(urlPattern: string, variables: any, fetchOptions?: any): Promise<any> {
      const queryHash = queryHashes[urlPattern];

      const template = makeTemplate(urlPattern);
      const url = template.fill({
        ...variables,
        h: queryHash,
      });

      if (!url) {
        return null;
      }

      const f = options?.fetch ?? globalThis.fetch;

      return f(url, { headers: fetchOptions?.headers });
    },
  };
}